/* eslint-disable prettier */
/**
 * PT BR Resource file
 */

import {
	roles,
	daySelection,
	GARoleTypeId,
	toggleCCPEntityDetail,
	readinessReportCategories,
	archiveReportQualifiedTypeId,
	natureOfEngagements,
	dashboardTabId,
	dashboardViews as dashboardViewsConstants,
	accountDesignations,
	groupRiskStatus,
	riskTypeIds
} from '../util/uiconstants';

export const labels = {
	clearFilter: "Limpar tudo",
	canvasOversight: "Canvas Oversight",
	oversight: "Supervisão",
	canvasLabel: "Canvas",
	myProjects: "Meus projetos",
	otherProjects: "Outros Projetos",
	priorProjects: "Projetos anteriores",
	completedProjects: "Projetos concluídos",
	completedLabel: "Concluído",
	createProject: "Criar projeto",
	rollForward: "Roll forward",
	rollForwardLabel: "Roll forward",
	rollForwardTitle: "Roll forward do seu projeto",
	project: "projeto",
	openProject: "Projeto aberto",
	manageUsers: "Gerenciar usuários",
	rollForwardInstructionalText: "Tem certeza de que deseja dar roll forward em seu projeto? <br> Isso permitirá que você use seu projeto concluído como modelo ao criar um novo projeto. As seguintes informações serão encaminhadas: nome do projeto, organograma, grupos e administradores de grupo. ",
	isClientUserError: "Não tem nenhum projeto ativo. Fale com um membro da equipe da EY para ser convidado para um projeto.",
	activeProjects: "Projetos ativos",
	myActiveProjects: "Meus projetos ativos",
	otherActiveProjects: "Outros projetos ativos",
	myCompletedProjects: "Meus projetos concluídos",
	myActiveProjectsPlaceholder: "Você tem acesso aos projetos da EY Canvas Oversight listados aqui. Selecione um nome de projeto para abri-lo ou clique em uma contagem para ver detalhes.",
	deleteProject: "Excluir projeto",
	deleteProjectModalText: "Tem certeza que deseja excluir este projeto? <br>O projeto será removido de sua página de destino e não será mais acessível para nenhum membro da equipe.",
	createButton: "Criar projeto",
	search: "Pesquisar",
	searchEngagement: "Pesquisar Engagement",
	searchEngagements: "Pesquisar Engagements",
	searchEntitiesAndEngagements: "Pesquisar entidades e engagements",
	searchClientList: "Pesquisar nome do cliente",
	noDataFound: "Não há dados para exibir.",
	expand: "Expandir",
	collapse: "Frequencia",
	more: "Mais",
	options: "Opções",
	editProject: "Editar Projeto",
	manageTeam: "Gerenciar equipe",
	markAsCompleted: "Marcar como concluído",
	connectedTo: "Ligado a",
	connectedClients: "Clientes conectados",
	connectedToClients: (count) => `${count} ${count == 1 ? 'cliente' : 'clientes'}`,
	connectedToEngagements: (count) => `Engagements: ${count == 0 ? 'Nenhum' : count}`,
	countEngagements: (count) => `${count}${count === 1 ? 'projeto' : 'projetos'}`,
	connectToEngagements: (count) => `Conectar ${count} ${count == 1 ? 'projeto' : 'projetos'}`,
	connectedToAccessGroups: (count) => `Ligado a ${count} ${count == 1 ? 'grupo' : 'grupos'}`,
	connectToAccessGroups: (count) => `Conectar ${count} ${count == 1 ? 'grupo' : 'grupos'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? 'Entidade' : 'Entidades'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? 'Visualização' : 'Visualizações'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? 'Domínio' : 'Domínios'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? 'Visualização' : 'Visualizações'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? 'Domínio' : 'Domínios'}`,
	engagement: "engagement",
	engagementNameLabel: "Nome de engagement",
	engagementPartnerLabel: "Sócios de engagement",
	partnerLabel: "Sócio",
	notInvited: "Não convidado.",
	clientNameLabel: "Nome do cliente",
	client: "Clientes",
	codeLabel: "Código",
	idLabel: "ID",
	engagements: "Engagement",
	engagementsLabel: "Engagements",
	noResultsFound: "Não foram encontrados resultados.",
	submit: "Enviar",
	saveAndContinue: "Salvar & Continuar",
	savecontinue: "salvar & continuar",
	saveDraft: "Salve como rascunho",
	closeLabel: "Fechar",
	step1: "Passo 1",
	step2: "Passo 2",
	step3: "Passo 3",
	step4: "Passo 4",
	step5: "Passo 5",
	adminsNoneLabel: "Nenhum",
	domainsAllLabel: "Todos",
	adminsHeaderLabel: "Administradores:",
	domainsHeaderLabel: "Domínios:",
	moreCountLabel: '+ {0}',
	selectClient: "Selecione um cliente",
	createOrgChart: "Criar gráfico org",
	connnectToCanvas: "Conecte-se à Canvas EY",
	viewSummary: "Ver resumo",
	viewLabel: "Ver",
	cancelLabel: "Cancelar",
	required: "Necessário",
	filter: "filtro",
	filtersWarningMessage: "Limite do filtro excedido. Apenas 25 filtros podem ser aplicados ao mesmo tempo.",
	back: "Voltar",
	save: "Salvar",
	saveClose: "Salvar & fechar",
	continue: "Continuar",
	finish: "Terminar",
	saveChanges: "Salvar alterações",
	projectName: "Nome do projeto",
	projectOwners: "Proprietários do projeto",
	addAnotherProjectOwner: "Adicionar outro proprietário de projeto",
	duplicateOwnerAdded: "Usuário duplicado",
	step1InstructionHeader: "Digite um nome para o seu projeto, adicione proprietários de projeto adicionais e selecione um ou mais clientes na lista abaixo para começar.",
	step1SubInstructionPart1: `Você deve ter acesso aos códigos GIS, GFIS ou Mercury do cliente ou a um engagement do EY Canvas para ver o nome do cliente abaixo. Os clientes que você selecionar nesta etapa determinarão quais engagements do EY Canvas que  estão disponíveis para conectar ao seu projeto. Para saber mais sobre como usar o EY Canvas Oversight, confira nosso {link}`,
	step2InstructionHeader: "Crie um gráfico organizacional para o seu projeto.",
	step2SubInstructionPart1: "O organograma deve refletir como seu cliente gerencia seus negócios. Ele será usado para resumir dados para os engagements do EY Canvas que você conecta ao seu projeto e para gerenciar o acesso de membros da equipe interna e externa. ",
	here: "aqui",
	zoomIn: "Mais zoom",
	zoomOut: "Menos zoom",
	expandAll: "Expandir tudo",
	collapseAll: "Recolher tudo",
	addLabel: "Adicionar",
	editLabel: "Editar",
	removeLabel: "Remover",
	noRowsTemplateStringPart1: "Não tem acesso a nenhum cliente. Clique",
	noRowsTemplateStringPart2: "para saber mais sobre como obter acesso. ",
	noRowSelected: "Selecione pelo menos um cliente para continuar.",
	firstName: "Primeiro nome",
	lastName: "Último nome",
	displayLanguage: "Linguagem de exibição",
	numberFormat: "Formato de número",
	dateFormat: "Formato de data",
	timezone: "Fuso horário",
	theme: "Tema",
	chooseDisplayTheme: "Escolha o tema de exibição padrão.",
	light: "Claro",
	dark: "Escuro",
	usersettings: "Configurações do Usuário",
	userOptions: "Opções de Usuário",
	clearHoverText: "Limpo",
	noFiltersAvailable: "Nenhum filtro disponível",
	dashboard: "Dashboard",
	milestones: "Milestones",
	activityFeed: "Feed de atividade",
	keyEvents: "Eventos-chaves",
	keyEventCompletion: "Conclusão do evento-chave",
	canvasClientPortal: "Canvas Client Portal",
	canvasClientPortalEy: "EY Canvas Client Portal",
	groupAudit: "Auditoria de grupo",
	projectManagement: "Gestão de projetos",
	reporting: "Relatórios",
	insights: "Insights",
	groupRiskAssessment: "Avaliação de risco de grupo",
	internal: "Interno",
	external: "Externo",
	members: "membros",
	show: "Mostrar",
	showDetails: "Mostrar detalhes",
	showMore: "Mostrar mais",
	showLess: "Mostrar menos",
	clientName: "Nome do cliente",
	clientsLabel: "Clientes",
	clientLabel: "Cliente",
	source: "Fonte",
	code: "Código",
	accessDelegatedBy: "Acesso delegado por ",
	returnToPreviousStep: "Voltar a um passo anterior",
	backButtonWarning: "Se você retornar a uma etapa anterior e fazer alterações, seu progresso nesta etapa pode ser impactado. <br> Selecione <b>Continuar</b> para retornar a uma etapa anterior ou <b>Cancelar</b> para permanecer nesta etapa.",
	step1SubInstructionPart3: "Os clientes que selecionar neste passo determinarão quais os Engagements do EY Canvas disponíveis para ligar o seu projeto.",
	step3InstructionHeader: "Selecione um ou mais Engagement EY Canvas, em seguida, arraste-os e coloque-os na sua carta organizacional.",
	step3InstructionPara: "A ligação entre os Engagements do EY Canvas e as entidades no seu gráfico organizacional determina como os dados do EY Canvas são resumidos no Dashboard para o seu projeto.",
	availableLabel: "Disponível",
	connectedLabel: "Conectado",
	milestoneSummaryView: "Milestone - Visão resumida",
	taskCompletionByMilestone: "Conclusão da tarefa por milestone",
	basedOnTaskCompletition: "Com base na conclusão da tarefa",
	scopeAndStrategy: "Scope & Strategy",
	execution: "Execução",
	conclusion: "Conclusão",
	step3ListDefaultMessage: "Não existem Engagements disponíveis para o(s) cliente(s) que selecionou no Passo 1. Volte ao Passo 1 e selecione um cliente diferente para continuar.",
	addNewEngagementLabel: "Adicionar novo engagement",
	selectedLabel: "selecionado",
	moreText: "mais",
	connectLabel: "Conectado",
	connectEngagements: "Engagement conectados",
	connectToAnEngagement: "Conecte-se a um engagement para iniciar",
	connectToAnAccessGroup: "Nenhum grupo foi conectado.",
	tasks: "Tarefas",
	organizationalChartHeading: "Entidades",
	groupAdministratorsLabel: "Administradores de grupos",
	step4InstructionHeader: "Crie grupos para o seu projeto e conecte-os a uma ou mais entidades no seu gráfico organizacional.",
	step4ImportantNote: "Nota importante: Os membros de um grupo podem visualizar os dados do engagement do EY Canvas para as entidades do organograma às quais você conecta o grupo e quaisquer filhos dessas entidades. Se você conectar um grupo a uma entidade-mãe em seu organograma, o grupo poderá visualizar os dados de engajamento do EY Canvas para a entidade-mãe e todos os seus filhos. ",
	addAGroup: "Adicionar um grupo",
	addGroup: "Adicionar grupo",
	searchGroup: "Grupos de pesquisa",
	addNewGroupHeader: "Criar um novo grupo aqui.",
	editNewGroupHeader: "Edite um grupo existente aqui.",
	addNewGroupInstruction: "Depois que seu projeto for criado, você pode convidar membros internos e externos da equipe para este grupo. Você tem a opção de adicionar um administrador de grupo que também pode convidar os membros para este grupo.",
	groupName: "Nome do grupo",
	groupAdministrators: "Administradores de grupo (opcional)",
	groupAdministratorsSubHeading: "Adicione um administrador de grupo. Os administradores de grupo podem convidar os membros para o seu projeto após a sua criação. Não podem editar as visualizações e domínios deste grupo.",
	clearAllValues: "Limpar",
	createGroupDashboardViews: "Visualizações do painel",
	dashboardViewsSubHeading: "Selecione pelo menos uma visualização. Isto determina os dados que os membros podem ver quando vêem o dashboard para o seu projeto.",
	duplicateDomain: "Domínio duplicado",
	allMilestones: "Todos os Milestones",
	someMilestonesSelected: "{0} milestones selecionados",
	noGroupsAdded: "Não foram acrescentados domínios para este projeto.",
	step5InstructionHeader: "Revise seu projeto EY Canvas Oversight.",
	step5SubInstruction: "Se você precisar fazer alterações, selecione o lápis Editar para retornar a uma etapa anterior. <b>Fazer alterações em uma etapa anterior pode afetar o progresso nas etapas posteriores.</b> ",
	associationNotRequired: "Associação não necessária",
	accessGroupAlreadyAddedToParent: "Você já associou um ou mais dos grupos selecionados a uma entidade principal. Se um grupo de acesso estiver conectado a uma entidade principal, então seus membros podem visualizar dados do engagement do EY Canvas para a entidade principal e todos as suas subsidiárias. Portanto, a associação não é necessária.",
	deleteGroupInstructionalText: "Tem certeza que quer excluir esse grupo? <br>Acessa excluída, a operação não pode ser desfeita. Os membros do grupo não poderão mais acessar seu projeto.",
	deleteGroup: "Excluir grupo",
	removeMember: "Remover um membro",
	removeMemberTitle: "Tem certeza que quer remover esse membro da equipe? Se o membro pertencer a vários grupos, então ele será removido de todos os grupos listados aqui e não conseguirá mais acessar este projeto. Se você quiser remover o membro apenas de um único grupo, selecione a opção <b>Edit</b> em vez disso.",
	teamMember: "Membro da equipe",
	clientNameLbl: "Clientes",
	help: "Ajuda",

	//Org char left rail
	filters: "Filtros",
	countEngagementSelected: "{0} de Engagement {1} selecionados",
	of: "{num} de",
	entityName: "Nome da entidade",
	enterEntityName: "Insira o nome aqui",
	projectOwner: "Dono do projeto",
	role: "Função",
	domains: "Domínios (opcional)",
	domainSubHeading: "Adicione pelo menos um domínio se os membros externos da equipe forem convidados para este grupo. Domínio refere-se aos caracteres após o símbolo @ em um endereço de e-mail. Para adicionar um membro externo da equipe, eles devem ter um domínio válido para este grupo.",
	addAdministrator: "Adicione um administrador de grupo",
	addNewDomain: "Adicione um novo domínio",
	addExistingDomain: "Adicione um domínio existente",
	placeholderStep3NoEngagementMessage: "Não existem Engagements disponíveis para o(s) cliente(s) que selecionou no Passo 1. Volte ao Passo 1 e selecione um cliente diferente para continuar.",
	placeholderStep3NoConnectedEngagementMessage: "Não há engagements conectados ainda. ",
	placeholderStep3AllEngagementsConnected: "Todos os compromissos disponíveis estão conectados ao seu projeto.",
	placeholderStep4NoConnectedGroupMessage: "Ainda não há grupos conectados.",
	domainName: "Nome de domínio",
	engagementLabel: "Engagement",
	start: "Começar",
	end: "Fim",
	suggestedEnd: "Fim sugerido",
	status: "Status",
	thereIsNoDataToDisplay: "Não há dados para mostrar.",
	selectadditionalEntitiesToContinue: "Selecione entidades adicionais para continuar.",
	comingSoonToDisplay: "O status do componente estará disponível em breve.",
	checkForUpdatesToDisplay: "Volte nas próximas semanas para atualizações.",
	userSearchPlaceholder: "Adicione o nome ou e-mail e pressione Enter para ver os resultados.",
	userSearchPlaceholderForExternal: "Adicione o e-mail e pressione enter para ver os resultados.",
	partnerInChargeInvitedToTheEngagement: "Sócio encarregado convidado para o engagement",
	partnerInChargeSignedOffOnCraSummary: "Sócio encarregado assinou o resumo do CRA",
	eqrSignedOffOnCraSummary: "EQR assinou o resumo do CRA",
	partnerInChargeSignedOffOnAuditPlan: "Sócio encarregado assinou plano de auditoria ",
	picInvited: "PIC convidado",
	picSignOffCRA: "Assinatura do PIC no CRA",
	picSignOffAuditPlan: "Assinatura do PIC no Plano de Auditoria",
	eqrSingOffCRA: "Assinatura do EQR no CRA",
	overdue: "vencido",
	outOf: "fora de",
	edit: "Editar",
	remove: "Remover",
	add: "Adicionar",
	admin: "Administradores",
	views: "Modos de exibição",
	domainLabel: "domínio",
	domainslabel: "Domínios",
	viewLabelText: "exibição",
	viewsLabelText: "Modos de exibição",
	administrators: "Administradores",
	none: "Nenhum",
	organizationChart: "organograma",
	invalidDomainName: "Nome de domínio inválido",
	lastRefreshed: "Última atualização",
	lastRefreshedActivityFeed: 'Activity feed data last refreshed',
	lastRefreshedReconciliation: "Dados de reconciliação atualizados por último",
	quickFilter: "Filtro rápido",
	notApplied: "Não aplicado",
	quickFilterInput: "Nome do filtro rápido",
	quickFilterSubHeaderText: "Quando você terminar, você pode aplicar o filtro rápido para refinar as entidades para as quais você gostaria de visualizar dados sem ter que selecionar individualmente cada uma delas.",
	createFilterTrigger: "Criar novo filtro",
	createFilterTitle: "Criar novo filtro rápido",
	createFilterButton: "Criar filtro rápido",
	createFilterHeaderText: "Selecione uma ou mais entidades de gráficos organizacionais para criar um filtro rápido.",
	createFilterSubHeaderText: "Quando você terminar, você pode aplicar o filtro rápido para refinar as entidades para as quais você gostaria de visualizar dados sem ter que selecionar individualmente cada uma delas.",
	editFilterTitle: "Editar filtro rápido",
	editFilterHeaderText: "Editar ou excluir um filtro rápido.",
	editFilterIconTitleTip: "Editar",
	oneRequired: "Pelo menos uma seleção é necessária.",
	noFiltersCreatedTitle: "Ainda não foram criados filtros rápidos.",
	noFiltersCreatedSubTitle: "Crie um filtro rápido para começar.",
	clear: "Limpar",
	completionRange: "Alcance de conclusão",
	engagementCount: "Contagem do engagement",
	clickOnAVisualBelowToFilterTheEngagementList: "Clique em um visual abaixo para filtrar a lista de engagement.",
	organizationalChartTooltip: "Selecione o Organograma para editar ou remover entidades do seu Projeto de Supervisão.",
	organizationalChart: "Organograma",

	//Task status chart labels
	open: "Aberto",
	inProgress: "Em andamento",
	inReview: "Em revisão",
	completeUpperCase: "Completo",
	taskStatusOverdue: "Vencido",
	noDataForSelections: "Não existem dados disponíveis para as suas seleções.",
	selectOneOrMoreMilestones: "Selecione um ou mais milestones diferentes para continuar.",
	milestoneDetailTitle: "Milestones - detalhe",
	taskStatusByMilestone: "Status da tarefa por milestone",
	milestoneDetailSubtitle: "Com base no status da tarefa",
	basedOnAllTasksForTheSelectedMilestone: "Com base em todas as tarefas para os milestones selecionados",
	totalTasks: "total de tarefas",
	noneSelected: "Nenhum selecionado",
	nameOrEmail: "Nome ou e-mail",
	remove: "Remover",
	milestonesTooltipText: "Progresso da auditoria por Milestones",
	canvasClientPortalTooltipText: "Solicitar status, incluindo itens vencidos, vencidos e devolvidos ",
	groudAuditTooltipText: "Status da equipe primária e componente, incluindo itens devolvidos e vencidos",
	projectManagementTooltipText: "Status das notas de revisão e atribuições, incluindo itens atrasados. Esta visualização não ficará visível para os clientes. ",
	insightsTootipText: "Comparação de riscos, procedimentos substantivos, estratégia de controle e resultados entre as equipes primárias e componentes. Esta visualização não será visível para os clientes. ",
	reportTootipText: "Prontidão do relatório, modificação e status de conclusão de tarefas por país",
	taskStatusComplete: "Status da tarefa - Completo",
	taskStatusInreview: "Status da tarefa - Em revisão",
	taskStatusInprogress: "Status da tarefa - Em andamento",
	taskStatusOpen: "Status da tarefa - Aberto",

	//Review Notes chart labels
	reviewNotesByStatusTitle: "Todas as notas de revisão",
	byStatus: "Por status",
	totalNotes: "notas totais",
	totalNotesLabel: "Notas totais",
	openNotes: "Abrir notas",
	byPriority: "Por prioridade",
	cleared: "Limpo",
	closed: "fechado",
	low: "Baixo",
	medium: "Médio",
	high: "Alto",
	critical: "Crítico",
	notesTableTooltipContent: "Com base em notas com status Aberto",

	// Group audit
	groupAuditTotalForms: "Formulários totais",
	groupAuditNotSent: "Não enviado",
	groupAuditUnlinked: "Desvinculado",
	totalTasksCapitalized: "Total de tarefas",
	primary: "Primário",
	component: "Componente",

	//Bar chart
	are: "são",
	complete: "completar",
	noMilestoneDataForSelection: "Não há data de milestones para exibir para esta fase de auditoria.",
	selectDifferentAuditPhase: "Selecione uma fase de auditoria diferente ou selecione entidades adicionais para continuar.",

	//Delegate
	delegateInstruction: "Delegue o acesso a outro membro da equipe para que eles possam criar projetos em seu nome. Insira o nome ou o endereço de e-mail de um membro da equipe para começar. Seus delegados terão acesso a todos os seus clientes. ",

	delegateAccess: "Gerencie delegados",
	addAnother: "Adicionar delegados",
	hideMyDelegate: "Ocultar designados",
	showMyDelegate: "Mostre  meus designados",
	noRecord: "Não foram encontrados resultados",
	duplicateUser: "Designado já adicionado",
	duplicateUserMessage: "Usuário já adicionado",
	addDelegates: "Adicionar delegados",
	delegateTo: "Delegado para",
	delegateFrom: "Delegada de",
	delegateToMsg: "Você não delegou seu acesso a nenhum membro da equipe.",
	delegateFromMsg: "Nenhum membro da equipe delegou seu acesso a você.",

	// Project dashboard left rail
	searchFilterPlaceholder: "Filtros de pesquisa",
	searchEntitiesPlaceholder: "Pesquisar entidades",
	outOfEngagements: "<b>{0}</b> dos Engagement <b>{1}</b>",
	engagementCompletedBasedOnTaskCompletion: "<b>{0}</b> engagement é <b>{1}</b> completo com base na conclusão da tarefa",
	engagementsCompletedBasedOnTaskCompletion: "<b>{0}</b> engagements <b>{1}</b> concluídos com base na conclusão da tarefa",
	engagementCompletedBasedOnTaskCompletionReporting: "<b>{0}</b> engagement completou <b>{1}</b> de tarefas",
	engagementsCompletedBasedOnTaskCompletionReporting: "<b>{0}</b> engagements completaram <b>{1}</b> de tarefas",
	engagementCompletedBasedOnTaskCompletionMilestone: "<b>{0}</b> engajamento completou <b>{1}</b> de tarefas para este milestone",
	engagementsCompletedBasedOnTaskCompletionMilestone: "<b>{0}</b> engagements completaram <b>{1}</b> de tarefas para este milestone",
	reportReleaseDate: "Data de conclusão do relatório",
	partnerInvited: "Sócio convidado",
	picSignoffOnCra: "Assinatura do PIC no CRA",
	eqrSignoffOnCra: "Assinatura do EQR no CRA",
	picSignoffOnAuditPlan: "Assinatura do PIC no plano de auditoria ",
	overdueLabel: "atrasado",

	//Team members
	teamMembersTitle: "Membros da equipe",
	membersTitle: "Membros",
	eyContactsTitle: "Contatos EY",
	allMembersLabel: "Todos os membros",
	internalMembersLabel: "Membros internos",
	externalMembersLabel: "Membros externos",
	groupsTitle: "Meus grupos",
	projectOwnersTitle: "Proprietários de projetos",
	projectOwnersLabel: "Donos do projeto",
	projectOwnerLabel: "Dono do projeto",

	//CCP
	summary: "Resumo",
	requestsByStatus: "Solicitações por status",
	totalRequests: "total de solicitações",
	totalRequestsTitle: "Total de solicitações",
	receivedByEy: "Recebido por EY",
	acceptedByEy: "Aceito por EY",
	outstandingByEy: "Excelente",
	returned: "Retornado",
	receivedByEyOnTime: "Recebido pela EY na hora",
	averageDaysOverdue: "Dias médios atrasados",
	outOfReceivedAndAccepted: "<b>{0}</b> de <b>{1}</b> solicitações recebidas e aceitas",
	outOfStandingRequests: "<b> {0} </b> de <b> {1} </b> pedidos pendentes",
	outOfAverageDaysOverdue: "<b> {0} </b> de <b> {1} </b> pedidos pendentes",
	draftRequests: "{0} pedidos de rascunho",
	noResultMessageHeader: "Não há dados para mostrar. Selecione entidades adicionais para continuar.",
	noResultMessageSubHeader: '',
	members: "membros",
	memberLabel: "membro",
	adminLabel: "Administrador",
	projectOwnerLabel: "Proprietário do projeto",
	viewsLabel: "Modos de exibição",
	metrics: "Métricas",
	yes: "Sim",
	no: "Não",
	emptyMessageAvailableGroup: "Nenhum grupo foi criado ainda. <br>Select <b>add a group</b> para começar.",
	thereIsNoDataToDisplayForThisEntity: "Não há dados para exibir para esta entidade.",
	typeLabel: "tipo",
	groupsLabel: "Grupos",
	group: "grupo",
	entitiesLabels: "Entidades",
	entityLabel: "Entidade",
	nameLabel: "nome",
	searchTeamMembers: "Pesquisar membros da equipe",
	notSelectedLabel: "Não selecionado",
	entitiesLabel: "Entidades",
	noDataAvailableLabel: "Não há dados disponíveis.",
	delete: "excluir",
	deleted: "Excluído",
	addAMember: "Adicione um membro",
	addMemberHeaderText: "Adicione um novo membro a um ou mais grupos para o seu projeto.",
	teamMemberInformation: "Informações sobre membros da equipe",
	teamMemberNote: "Digite o nome ou e-mail para o membro interno ou externo da equipe que você deseja adicionar aos grupos selecionados. Pressione a tecla Enter para ver os resultados.",
	selectGroupNote: "Selecione pelo menos um grupo. Os membros do grupo podem visualizar os dados do engagement do EY Canvas para todas as entidades do organograma a que seus grupos estão conectados, bem como a quaisquer filhos dessas entidades.",
	inviteAndClose: "Convidar e fechar",
	inviteAndAddAnother: "Convide e adicione outro",
	contacts: "Contatos",
	email: "Email",
	emailAll: "E-mail todos",
	contactTeam: "Equipe de contato",
	emptyMessage: "Não há contatos disponíveis para este engagement.",
	comingDue: "Chegando",
	tomorrow: "amanhã",
	next3days: "Próximos 3 dias",
	next5days: "Próximos 5 dias",
	next10days: "Próximos 10 dias",
	next30days: "Nos próximos 30 dias",
	comingDueNext5days: "Vencimento (próximos 5 dias)",
	entityDetails: "Detalhes da entidade",
	requestsByEntity: "Pedidos por entidade",
	basedOnTheSelectedCategory: "Com base na categoria selecionada",
	requestCount: "Contagem de pedidos",
	selectedDay: "Dia selecionado",
	editMember: "Editar membro",
	editMemberHeaderText: "Edite os grupos aos os que o membro da equipe selecionada tem acesso.",
	editaGroup: "Editar grupo",
	editAGroupHere: "Edite um grupo aqui",
	selectAnotherFrame: "Selecione outro período de tempo para visualizar dados.",
	emptyFrameShort: "Selecione entidades adicionais para continuar.",
	emptyFrame: "Selecione entidades adicionais ou um período de tempo diferente para continuar.",
	editMemberHeaderText: "Edite os grupos aos os que o membro da equipe selecionada tem acesso.",
	confirm: "confirmar",
	markCompleteModalInstrTextPart1: "Tem certeza que quer concluir esse projeto?",
	markCompleteModalInstrTextPart2: "Uma vez que você tome esta ação, ela não pode ser desfeita. Projetos concluídos podem ser lançados para a frente e usados como modelo ao criar um novo projeto.",
	firstPage: "Primeira página",
	lastPage: "Última página",
	nextPage: "Próxima página",
	prevPage: "Página anterior",

	// Add Tag
	keyContacts: "Contatos principais",
	customTags: "Marcações personalizadas",

	// Manage Tags
	manageTagInstructional: "Crie novas marcações personalizadas aqui. Você também pode editar e excluir  marcação personalizadas existentes. A marcação de contatos oferece flexibilidade para gerenciar contatos em seu projeto EY Canvas Oversight.",
	emptyCustomTagsList: "Nenhuma marcação personalizada foi criada ainda.",
	manageTagTitle: "Gerenciar marcações personalizadas",
	manageTagLinkButton: "Gerenciar marcações  ",
	color: "Cor",
	tagName: "Nome",
	tagDelete: "Excluir",
	tagCreate: "Criar nova marcação",
	customTagsHeader: "Marcações personalizadas",

	//preparer assignment tile
	totalPreparerAssignments: "Total de atribuições para o preparador",
	inprogress: "em andamento",
	preparerAssignments: "Atribuições de preparação",
	byAssignmentStatus: "Por status de atribuição",
	taskWithoutPreparerAssignments: "tarefa sem atribuições de preparador ",
	tasksWithoutPreparerAssignments: "tarefas sem atribuições de preparador ",
	preparerFilterTitle: "Preparador",

	// reviewer assignment tile
	totalReviewerAssignments: "Total de atribuições para o revisor",
	taskWithoutReviewerAssignments: "tarefa sem atribuições de revisor",
	tasksWithoutReviewerAssignments: "tarefas sem atribuições de revisor",
	reviewerFilterTitle: "Revisor",

	assignments: "Atribuições",
	notes: "Notas",
	preparerNotAssigned: "Preparador não atribuído",
	reviewerAssignments: "Atribuições de revisores",
	reviewerNotAssigned: "Revisor não atribuído",
	basedOnPreparerAssignments: "Com base em atribuições de preparação",
	basedOnPreparerAssignmentsOpenAndInProgress: "Com base em atribuições de preparação com o status Open e In Progress",
	basedOnReviewerAssignments: "Com base em atribuições de revisores",
	basedOnReviewerAssignmentsOpenAndInProgress: "Com base em atribuições de revisores com status Aberto e Em Progresso",

	statusOpen: "Status - Aberto",
	statusInProgress: "Status - Em andamento",
	statusClosed: "Status - Fechado",
	byPriorityLow: "Por prioridade - Baixa",
	byPriotityMedium: "Por prioridade - Média",
	byPriorityHigh: "Por prioridade - Alta",
	byPriorityCritical: "Por prioridade - Crítica",

	findingsLabel: "Resultados",
	riskLabel: "Riscos",
	digitalAuditLabel: "Auditoria digital",
	digitalAuditStrategy: "Estratégia de auditoria digital",
	byDigitalAuditTypeLabel: "Por estratégia de auditoria digital",
	basedOnProfileSelection: "Com base na seleção de perfil",
	basedOnSelectionArchiveForm: "Com base na seleção no formulário de archive ",
	MisstatementsByType: "Distorções por tipo ",
	DeficienciesBySeverity: "Deficiências por severidade",
	MisstatementsLabel: "Distorções",
	DeficienciesLabel: "Deficiências",
	primarTeamDeficiencyHeader: "Equipes primárias - {0}",
	componentRegionalTeamDeficiencyHeader: "Equipes regionais e componentes - {0}",
	auditTileHeaderTextPrimary: "Equipes primárias - {0}",
	componentRegionalTeamHeader: "Equipes regionais e componentes - {0}",
	allTeamDeficiencyHeader: "Todos os engagements - {0}",
	primarTeamMisstatementHeader: "Equipes primárias - {0}",
	componentRegionalTeamMisstatementHeader: "Equipes regionais e componentes - {0}",
	allTeamMisstatementHeader: "Todos os engagements - {0}",
	deficiencyLabel: "Deficiência",
	inherenRisktLabel: "Risco de distorção material",
	significantRiskLabel: "Significativo",
	fraudRiskLabel: "Fraude",
	significantDeficiencyLabel: "Deficiência significativa",
	materialWeaknessLabel: "Fraqueza material",
	factualLabel: "Real",
	projectedLabel: "Projetada",
	judgmentalLabel: "Julgamento",
	reclassificationLabel: "Reclassificação",
	totalDeficiencyLabel: "deficiência total",
	totalRiskLabel: "risco total",
	totalRisksLabel: "riscos totais",
	totalDeficienciesLabel: "deficiências totais",
	totalMisstatementLabel: "distorção total ",
	totalMisstatementsLabel: "distorções totais",
	allEngagementHeader: "Todos os engagements - {0}",
	noAuditSightGroupData: "<b> Não há dados de auditoria de grupo para exibir. </b> <br> Selecione <b> Todos </b> no botão de alternância para ver os dados resumidos. ",
	noAuditTileDataPlaceholder: "Não há dados para exibir. Selecione entidades adicionais para continuar.",
	openReviewNotes: "Abrir notas de revisão",
	byPriorityLevel: "Por prioridade",
	risks: "Riscos",
	groupRoleLabel: "Função do grupo",
	totalRisks: "Riscos totais",
	byType: "Por tipo",
	inherent: "Risco de distorção material",
	significant: "Significativo",
	fraud: "Fraude",
	strategy: "Estratégia",
	notApplicable: "Não aplicável",
	customizableTable: "Personalizar tabela",
	selectUpToOptionHeader: "Selecione até {0} opções",
	selectUpToThreeOptionHeader: "Selecione até três opções",
	selectUpToFourOptionHeader: "Selecione até quatro opções",
	psps: "PSPs",
	osps: "OSPs",
	hxpsps: "HxPSPs",
	totalSubstantiveProcedures: "procedimentos substantivos totais",
	totalSubstantiveProcedure: "procedimentos substantivos totais",
	totalITControls: " ITGCs e ITSPs totais",
	totalITControl: "ITGC total e ITSP",
	testing: "Testar",
	nonTesting: "Não testar",
	auditStrategy: "Estratégia de auditoria",
	totalControls: "controles totais",
	totalControl: "controle total",
	removeProject: "Remover o projeto",
	removeProjectInstructionalText: "Tem certeza de que deseja remover o seguinte projeto da sua lista de projetos ativos? <br>Se você remover o projeto, você não poderá mais acessá-lo.",
	substantiveProcedures: "Substantivo",
	controls: "Controles",
	itlabel: "IT",

	//delegates removed
	userDelTitle: "Meus delegados",
	delTitleDetail: "Você delegou seu acesso aos membros da equipe listados aqui. Seus delegados têm acesso a todos os clientes aos que você tem acesso.",
	delElseMsg: "Você não adicionou nenhum delegado ainda.",
	delegateTitle: "Remova um delegado",
	delegateMember: "Delegado ",
	deleteMessage: "Tem certeza que quer remover esse delegado <br/>? Uma vez removidos, eles não poderão mais criar projetos em seu nome.",

	//Advanced filters.
	advancedFilters: "Filtros avançados",
	selectAll: "Selecione todos",
	deselectAll: "Desmarque todos",
	applyFilters: "Aplique filtros",
	region: "Região",
	country: "País",
	city: "Cidade",
	state: "Estado",
	advancedFiltersInstructionalText: "Selecione as entidades para as quais você gostaria de visualizar os dados do engagement.",
	advancedFiltersInstructionalTextLine2: "Entidades às quais você não tem acesso aparecem desativadas. Fale com um administrador de grupo se precisar de acesso. ",
	engagementsSelected: "engagement(s) selecionado",
	filterYes: "Sim",
	filterNo: "Não",

	//Group Audit
	pendingResponse: "Resposta pendente",
	primaryTileTitle: "Status da equipe primária",
	reportingFormStatus: "Status do formulário de emissão de relatórios",
	reportingForm: "Formulário de Reporting",
	summarizedForPrimaryTeams: "Resumido para equipes primárias",
	primaryTileSubtitle: "formulários de relatório de grupo enviados",
	received: "Recebido",
	dueToPrimaryTeam: "Devido à equipe primária",
	sentToPrimaryTeam: "Enviado para a equipe primária",
	evidencePending: "Evidências pendentes",
	evidenceComplete: "Provas completas",
	componentTileTitle: "Status da equipe de componentes",
	componentTaskStatus: "Status da tarefa de componentes",
	componentTask: "Tarefa de componente",
	comingsoonTaskStatus: "Em breve",
	summarizedForComponentTeams: "Resumido para equipes componentes",
	componentTileSubtitle: "tarefas de auditoria de grupo recebidas",
	unlinkedTask: "tarefa desvinculada",
	unlinkedTasks: "tarefas desvinculadas",

	//Group Risk Assessment
	groupRiskAssessmentTitle: "Riscos",
	groupRiskSummaryTitle: "Avaliação de risco de grupo",

	// Reporting
	reportModifications: "Modificações no relatório",
	byReportType: "Por tipo de relatório",
	notSelected: "Não selecionado",
	unmodified: "Não modificado",
	modified: "Modificado",
	reports: "Relatórios",
	opinions: "opiniões",
	modifiedReports: "Relatórios modificados",
	modifiedOpinions: "Opiniões modificadas",
	adverse: "Adverso",
	disclaimer: "Abstenção ",
	qualification: "Qualificação",
	qualified: "Qualificado",
	engagementReportTooltip: "Apenas os engagements com datas de relatórios em ou antes da data atual são resumidos aqui. Todos os engagements são exibidos na tabela abaixo.",
	geography: "Geografia",
	standars: "Normas",
	gaap: "GAAP",
	gaapUs: "GAAP EUA",
	ifrs: "IFRS",
	other: "Outro",
	yearEndDate: "Data de fim de ano",
	endDateOfPeriodCovered: "Data final do período coberto",
	reportDate: "Data do relatório",
	archiveDeadline: "Prazo de arquivamento",
	reportType: "Tipo de relatório",
	opinionType: "Tipo de opinião",
	taskStatus: "Status da tarefa",
	exportData: "Dados de exportação",
	exportToExcel: "Exportar",
	orgChartEntity: "Entidade de gráficos org",
	engagementId: "ID do engagment",
	contactName: "Nome de contato",
	contactEmail: "E-mail de contato",
	statusInherent: 'By Type - Risk of material misstatement',
	statusSignificant: "Por Tipo - Significativo",
	statusFraud: "Por Tipo - Fraude",
	substantivePSPs: "Substantivo - PSPs",
	substantiveOSPs: "Substantivo - OSPs",
	substantiveHxPSPs: "Substantivo - HxPSPs",
	controlsTesting: "Controles - testes",
	controlsNonTesting: "Controles - Sem teste ",
	iTTesting: "TI - teste",
	iTNonTesting: "IT - Sem teste ",
	misstatementsFactual: "Distorções - Factual ",
	misstatementsProjected: "Distorções - Projetadas ",
	misstatementsJudgmental: "Distorções - Julgamento ",
	misstatementsReclassification: "Distorções - Reclassificação ",
	deficienciesDeficiency: "Deficiências - Deficiência",
	deficienciesSignificantdeficiency: "Deficiências - Deficiência significativa",
	deficienciesMaterialweakness: "Deficiências - Falha material",
	statusComplete: "Status - Completo",
	statusInReview: "Status - Em revisão",
	statusInProgress: "Status - Em andamento",
	statusOpen: "Status - Aberto",
	statusNotSent: "Status - Não enviado",
	statusReturned: "Status - Devolvido",
	statusDocumentationPending: "Status - Documentação pendente",
	statusDocumentationComplete: "Status - Documentação completa",
	statusReceivedbyEY: "Status - Recebido por EY",
	statusAcceptedbyEY: "Status - Aceito pela EY",
	statusOutstanding: "Status - Excelente",
	noCompletedProjectsMessagePart1: "Você não tem nenhum projeto concluído.",
	noCompletedProjectsMessagePart2: "Se você é um proprietário do projeto, então você pode marcar um projeto como concluído. Projetos concluídos podem ser lançados para a frente e usados como modelo na criação de um novo projeto.",
	noCompletedProjectsMessage: "Você não tem nenhum projeto concluído. <br>Se você for o proprietário do projeto, poderá marcar o projeto como concluído. Os projetos concluídos podem ser avançados e usados como modelo ao criar um novo projeto. ",
	requests: "Solicitações",

	//Reporting readiness report
	week: "semana",
	weeks: "Semanas",
	readinessReportTitle: "Relatório de prontidão ",
	taskCompletionByEngagement: "Conclusão da tarefa por engagement",
	readinessLegendTitle: "Proximidade da data do relatório ",
	basedOnReportDateProximityForEachEngagement: "Com base na proximidade da data do relatório para cada engagement",

	//ReportCompletion
	taskCompletionStatus: "Status de conclusão da tarefa",
	taskCompletionByLocation: "Conclusão da tarefa por localização",
	basedOnCompletedTasksForEachEngagement: "Com base em tarefas concluídas para cada engagement",
	byGeography: "Por geografia",
	taskCompletion: "Conclusão da tarefa",
	completedTasks: "tarefas concluídas",

	engagementArchived: "Este engagement foi arquivado. Os dados não estão mais disponíveis.",
	externalUsersNoActiveProjMessage: "Você não tem nenhum projeto ativo. Fale com um membro da equipe EY para ter acesso.",

	//Error Messages
	networkErrorMessage: "A rede de aplicativos está enfrentando um erro. Atualize a página e tente novamente mais tarde. Entre em contato com o Help desk se o erro persistir.",
	genericErrorMessage: "A operação selecionada não pôde ser concluída neste momento. Atualize a página e tente novamente. Entre em contato com o Help desk se o erro persistir.",
	otherProjectPlaceholder: "Seus engagements no EY Canvas estão conectados aos projetos do EY Canvas Oversight listados aqui. Você não tem acesso a esses projetos. Fale com um proprietário do projeto ou administrador de grupo para ter acesso.",
	noProjectsAvailable: "Não há projetos disponíveis.",
	completedProjectPlaceholder: "Seus projetos completos de Supervisão de  EY Canvas estão listados aqui. Selecione a <b> Roll forward </b>opção para usar seu projeto completo como modelo ao criar um novo projeto.",
	completedNotProjectPlaceholder: "Você não tem nenhum projeto concluído. <br>Se você for o proprietário do projeto, poderá marcar o projeto como concluído. Os projetos concluídos podem ser avançados e usados como modelo ao criar um novo projeto. ",

	//Log out and time out modal
	logoutModalTitle: "Logout automático para sua proteção ",
	sessionTimerMsgLine1: "Devido à inatividade, sua sessão de trabalho atual está prestes a expirar. ",
	sessionTimerMsgLine2: "Para sua segurança, as sessões do EY Canvas Oversight terminam automaticamente após 30 minutos de inatividade. ",
	sessionTimerMsgLine3: "Sua sessão atual irá expirar em {0} minutos. ",
	sessionTimerMsgLine4: "Se você deseja permanecer logado, por favor clique",
	modalContinueButton: "<b> Continuar </b> ",
	modalLogoutButton: "Sair",
	modalCloseButton: "Fechar ",
	countryNotAvailable: "País não disponível ",
	regionNotAvailable: "Região não disponível",
	notAvailable: "Não disponível",
	signout: "Sair",
	engagementTypeNotAvailable: "Tipo de engajament não disponível",

	// Admin portal
	administration: "Administração",
	mainPageInstructionalText: "Bem-vindo aoEY Canvas Oversight Administrative Portal",
	manageProjectsFormatted: "Gerenciar <br />projetos",
	manageUsersFomatted: "Gerenciar <br />usuários",
	manageAdminsFormatted: "Gerenciar <br />Administradores de Oversight",
	homeLabel: "Home",
	userNotFoundError: "Usuário não encontrado.",
	manageUsersInstructionalText: "Procure um usuário inserindo sua GUI",
	selectRole: "Selecione a função",
	role: "Função",

	//Manage User
	manageUsersTitle: "Gerenciar usuários",
	otherProjectsTabTitle: "Outros projetos",
	validGuiErrorMsg: "Insira uma GUI válida",
	accessibleProjects: "Projetos acessíveis",
	delegates: "Delegados",
	projectID: "ID do Projeto",
	projectStatus: "Status do projeto",
	gui: "GUI",
	emailAddress: "Endereço de email",
	userRole: "Função do usuário",
	userID: "ID do usuário",
	noResultMessage: "Nenhum resultado corresponde aos critérios de pesquisa.",
	noResultFound: "Não foram encontrados registros.",
	userDetails: "Detalhes do usuário",
	active: "Ativo",
	inActive: "Inativo",
	manageAdmins: "Gerenciar administradores do EY Canvas Oversight",
	manageAdminsInstructionalText: "Todos os administradores do EY Canvas Oversight estão listados abaixo. Você pode editar as funções de um administrador, adicionar e remover administradores.",
	adminReader: "Leitor de administração de aplicativos",
	adminWriter: "Escritor de administrador de aplicativos",
	superAdmin: "Super administrador de aplicativos",
	revertChanges: "Reverter mudanças",
	unSavedChanges: "Mudanças não salvas",
	unSavedChangesMessage: "Você tem alterações não salvas que serão perdidas se você continuar. <br/> Selecione <b>Confirmar</b> para continuar. Selecione <b>Cancelar</b> para retornar à página subjacente e salvar suas alterações.",
	addNewAdmin: "Adicionar novo administrador",
	addEYContactInstructions: "Digite um nome ou endereço de e-mail e pressione Enter para ver os resultados. Selecione uma função para adicionar um novo administrador de Supervisão.",

	// ManageProjects
	orgChartEntities: "Entidades do organograma",
	manageProjectsInstructionalText: "Pesquise um projeto inserindo o ID do projeto.",
	projectDetails: "Detalhes do projeto",
	parentEntity: "Entidade-mãe",
	connectedGroups: "Grupos conectados",
	validProjectIDError: "Insira um ID de projeto válido",
	addNewMember: "Adicionar membro",
	adminAddMemberInstructionalText: "Procure um usuário e selecione os grupos aos quais ele deve ser adicionado.",
	currentApplication: "Aplicativo atual",

	//Software Update
	softwareUpdate: "Atualizações de software",
	updateNow: "Atualizar agora",
	updateMsg: "Atualizações de software estão disponívels pelo EY Canvas Oversight. Selecione Atualizar Agora para baixar e instalar todas as atualizações. A página será atualizada.",

	//ContactDB
	placeholderForSearch: "Pesquisar",
	contactClearAll: "Limpar tudo",
	contactShowMoreFilters: "mais",
	contactListFilter: "Acesso à lista de contatos",
	dashboardAccessFilter: "Acesso ao Painel",
	groupRoleFilter: "Função do grupo",
	tagFilter: "Marcações",
	countryFilter: "País",
	serviceLineFilter: "Linha de serviço",
	typeFilter: "Tipo",
	roleFilter: "Função",
	dashboardAccess: "Painel de acesso",
	contactList: "Lista de contatos",
	noEntitiesMessage1: "Não há dados para exibir.",
	noEntitiesMessage2: "Selecione entidades adicionais para continuar.",
	noContacts: "Não existem contactos para esta entidade.",
	engagementsContacts: "Projetos",
	manuallyAdded: "Adicionado manualmente",
	dashboardViews: "visualizações",
	columnName: "Nome",
	columnEmail: "E-mail",
	columnEngagement: "Projetos",
	columnType: "Tipo",
	columnRole: "Função",
	columnServiceLine: "Linha de serviço",
	columnDashboard: "Acesso ao Painel",
	columnDashboardView: "Visualizações do painel",
	columnContactList: "Acesso à lista de contatos",
	columnTags: "Marcações",
	columnEntity: "Entidade",
	noResults: "Nenhum resultado encontrado",
	noResultsAvailable: "Não há dados disponíveis.",
	searchContacts: "Pesquisar contatos",
	selectedContacts: "Contatos selecionados",
	tag: "Marcação",
	manageAccess: "Gerenciar acesso",
	formLengthMessage: "O texto não pode exceder {number} caracteres.",
	viewMoreColumns: "Ver mais colunas",
	projectOwnerBadge: "Dono do projeto",
	entityAdminBadge: "Administradores da entidade",
	eyTeam: "Equipe da EY",
	clientTeam: "Equipe do cliente",
	userProfile: "Perfil de usuário",
	columnGroupRiskAssessment: "Acesso à avaliação de risco do Grupo",
	externalUserDenyMessage: 'External users cannot be granted access to the Group risk assessment module.',
	//ContactDB - Toolbar
	toolbarAddContact: "Adicionar contato",
	toolbarAccessLog: "Registro de acesso",
	toolbarMessageLog: "Registro de mensagens",
	toolbarCustomizeTable: "Personalizar tabela",
	toolbarExportData: "Exportar dados",
	toolbarManageAccess: "Gerenciar acesso",
	toolbarDefineAttributes: "Definir atributos",
	toolbarGenerateMessage: "Gerar mensagem",
	toolbarTags: "Etiquetas",
	toolbarRemove: "Remover",

	//ContactDB - Add Contact Modal
	addContactLabel: "Adicionar contato",
	addContactTitle: "Adicionar contatos",
	addContactInstructional: "Adicione um ou mais contatos ao seu projeto do EY Canvas Oversight. Se os contatos que você está adicionando exigirem acesso ao Painel ou à Lista de contatos, você pode conceder acesso a eles aqui.",
	columnEntities: "Entidades",
	noEntities: "Nenhum",
	duplicatedUser: "já foi adicionado como contato. Você pode gerenciar o acesso deles na lista de contatos.",
	accessToDashboard: "Acesso ao Painel",
	dashBoardsViews: "Acesso e visualizações do painel",
	placeholderEntities: "Entidades",
	placeholderAccess: "Acesso",
	placeholderAttributes: "Atributos",
	placeholderTags: "Marcações",
	projectOwnerAccessLabel: "Acesso do Proprietário do Projeto",
	entityAdminAccessLabel: "Acesso de Administrador de Entidade",
	accessToContactListLabel: "Acesso à lista de contatos",
	saveContactLabel: "Salvar",
	cancelContactLabel: "Cancelar",
	noContactsAdded: "Nenhum contato foi adicionado ainda.",
	noCustomColumns: "Nenhuma coluna personalizada foi criada para seu projeto.",
	toggleContactYes: "Sim",
	toggleContactNo: "Não",
	mustSelectOneEntity: "Você deve selecionar pelo menos uma entidade para continuar.",
	mustSelectOneView: "Selecione pelo menos uma visualização para todos os contatos aos quais você está concedendo acesso ao EY Canvas Oversight Dashboard.",
	mustBeOnwerOrAdministrator: "Você deve ser um dono de projeto ou administrador de entidade para executar esta ação. Atualize as entidades selecionadas para continuar.",
	cannotEditAccessForProjectOwners: "Você não pode editar o acesso dos donos do projeto: {list}",
	attributesLabel: "Atributos",
	externalUserDomainMismatch: "O domínio não é permitido para uma ou mais entidades selecionadas. Adicione os domínios necessários no fluxo de configuração da entidade e tente novamente.",
	projectOwnerAccessToogleInfo: "Um Proprietário do Projeto tem permissões totais para um projeto do EY Oversight",
	entityAdminAccessToogleInfo: "Um Administrador da Entidade tem permissões específicas da Entidade para executar tasks administrativas, conforme necessário.",

	//ContactDB-CustomizeTable Modal
	customizeTableModal: "Personalizar tabela",
	InstructionalTextCustomizeTableModal: "Selecione as colunas que deseja visualizar.",
	cancelCustomizeTable: "Cancelar",
	saveCustomizeTable: "Salvar",
	tooltipCustomizeTable: "Personalizar tabela",
	standardColumns: "Colunas padrão",
	customColumns: "Colunas personalizadas",
	closeTitleModal: "Fechar",
	addCustomColumn: "Adicionar coluna personalizada",
	editCustomColum: "Editar coluna personalizada",
	addCustomColumnLegend: "As colunas personalizadas permitem capturar e gerenciar atributos adicionais sobre seus contatos. Você pode criar até cinco colunas personalizadas para seu projeto. Depois de criar uma coluna, você pode selecionar um ou mais contatos e definir um atributo. Se você remover uma coluna personalizada, os atributos dos contatos também serão removidos.",
	deleteCustomColumnLegend: "Selecione o ícone <b>Excluir</b> para excluir uma coluna personalizada. Se você continuar, ele não estará mais disponível para o seu projeto. Todos os atributos que você aplicou anteriormente aos contatos também serão excluídos.",
	customColumnName: "Nome da coluna",
	attribute: "Atributo",
	attributes1to5: "Atributos (1-5)",
	visibleToExternal: "Visível para contatos externos",
	noCustomColumnMsg: 'No custom column added',

	//ContactDB - Add Contact Modal
	filterTooltip: "Filtrar",
	searchTitletip: "Pesquisar",
	addExternalContactColumnName: "Nome",
	addExternalContactColumnDomain: "Domínio",
	confirmDomain: "Confirmar domínio",

	//ContactDB - Profile Modal
	profileModalTitle: "Perfil",
	profileModalAccessSection: "Acesso",
	profileModalCustomAttributesSection: "Atributos personalizados",
	profileModalDashboardSection: "Visualizações do painel",

	//ContactDB - Generate Message
	selectMessageRecipients: "Selecione os destinatários da mensagem",
	notification: "Notificação",
	generateMessage: "Gerar mensagem",
	gmInstructionalText: "Envie um e-mail ou notificação para os contatos que você selecionou. As notificações só podem ser enviadas para contatos internos. Os e-mails podem ser enviados para contatos internos e externos.",
	messageType: "Tipo de mensagem",
	messageRecipient: "Destinatários da mensagem",
	selectContactsNow: "Selecione contatos agora",
	useSelectedContacts: "Usar contatos selecionados",
	moreFilters: "+ Mais filtros",
	countries: "Países",
	groupRoles: "Funções do grupo",
	groupRole: "Função de grupo ",
	roles: "Funções",
	role: "Função",
	serviceLines: "Linha de serviço",
	serviceLine: "Linha de serviço",
	contatcs: "Contatos",
	singularContact: "Contato ",
	singularEngagement: "Projeto",
	allContact: "Todos os contatos",
	allEntitles: "Todas as entidades",
	allCountries: "Todos os países",
	allGroupRoles: "Todas as funções do grupo",
	allEngagements: "Todos os projetos",
	allServicesLines: "Todas as linhas de serviço",
	allRoles: "Todas as funções",
	subject: "Assunto",
	removeTooltip: "Remover",
	fromEntity: "Da entidade",
	fromEngagement: "Do projeto",
	notificationMessage: "Mensagem de notificação",
	linkLabel: "Rótulo do link (opcional)",
	link: "Link (opcional)",
	fromEntityNotification: "Da entidade",
	mustSelectOne: "Você deve selecionar pelo menos um contato para continuar.",
	emailSentMsg: "Uma mensagem de e-mail foi gerada para os contatos selecionados.",
	notificationSentMsg: "Uma notificação foi enviada aos contatos selecionados.",
	messageFrom: "Mensagem de",
	duplicateMessage: "Mensagem duplcada",
	someEntities: '{0} entities selected',

	//ContactDB - Message Log
	messageLogInstruction: "Revise a lista de mensagens enviadas pela sua entidade. Se precisar enviar uma mensagem de acompanhamento, você tem a opção de duplicar as mensagens anteriores.",
	messageLogTitle: "Registro de mensagens",
	today: "Hoje",
	yesterday: "Ontem",
	thisWeek: "Esta semana ",
	lastWeek: "Semana passada",
	twoWeeksAgo: "Duas semanas atrás",
	older: "Mais antigo",
	notificationTo: "Notificação para",
	emailTo: "Email para",
	sentBy: "Enviado por",
	from: "De",
	date: "Data",
	time: "Tempo",
	subject: "Assunto",
	multiContatcsLowerCase: "contatos",
	singleContactLowerCase: "contato ",
	seeMore: "Ver mais",
	seeLess: "Ver menos",
	messageLogEmptyMessage: "Nenhuma mensagem foi enviada ainda.",
	messageLogFileExported: "Registro de mensagens",
	typeColumnToExportToExcel: "Tipo",
	sentByColumnToExportToExcel: "Enviado por",
	fromColumnToExportToExcel: "De",
	dateColumnToExportToExcel: "Data",
	timeColumnToExportToExcel: "Tempo",
	subjectColumnToExportToExcel: "Assunto",
	contactsColumnToExportToExcel: "Contatos",
	emailExportToExcel: "E-mail",
	notificationExportToExcel: "Notificação",

	//ContactDB - Access Log
	accessLog: "Log de acesso",
	accessLogInstructional: "Revise os membros da equipe apresentados abaixo e decida se deseja adicioná-los ou removê-los como contatos.",
	addAll: "Adicionar tudo",
	removeAll: "Deletar tudo",
	ignoreAll: "Ignorar tudo",
	contactsToAddEmpty: "Não há contatos em potencial para adicionar no momento.",
	contactsToRemoveEmpty: "Não há contatos em potencial para remover no momento.",
	ignore: "Ignorar",
	addAllConfirmationModal: "Um ou mais usuários possuem um domínio não permitido por uma entidade. Clique em Continuar para adicionar os usuários à lista de contatos. O(s) domínio(s) será(ão) importado(s) e adicionado(s) à lista de domínios permitidos para a entidade.",
	addConfirmationModal: "O usuário possui um domínio que não é permitido por esta entidade. Clique em Continuar para adicionar o usuário à lista de contatos. O domínio será importado e adicionado à lista de domínios permitidos para a entidade.",

	// ContactDB - Message Log - Filter
	messageTypeFilter: "Tipo de mensagem",
	sentByFilter: "Enviado por",
	fromEntityFilter: "Da entidade",
	toEntityFilter: "Para a entidade",
	toCountryFilter: "Para a país",
	toGroupRoleFilter: "Para função de grupo",
	toEngagementFilter: "Para o engagement",
	toServiceLineFilter: "Para a linha de serviço",
	toRoleFilter: "Para a função",

	//ContactDB - Define Attributes
	defineAttributes: "Definir atributos",

	// ContactDB Edit Entity Modal
	// Step 2 - Edit Entity Modal
	addAnotherEntityAdministrator: "Adicionar outro administrador de entidade",
	editEntity: "Editar entidade",
	entityAdministrators: "Administradores de entidade (opcional)",
	editEntityAdministratorsInstruction: "Você tem a opção de adicionar um ou mais administradores de entidade. Eles podem adicionar contatos a esta entidade e fornecer acesso aos módulos EY Canvas Oversight.",
	editEntityDomainInstruction: "Os membros da equipe externa devem ter um domínio válido para esta entidade para acessar o EY Canvas Oversight. O sistema importará os domínios aprovados dos engagements do EY Canvas conectados na Etapa 4 do assistente de configuração. Se você planeja convidar outros membros externos da equipe para esta entidade, adicione um ou mais domínios. Um domínio é o caracter após o símbolo @ em um endereço de e-mail.",
	level: "Nível {0}",

	// ContactDB Remove Contacts
	removeIcon: "Remover",
	removeContactTitle: 'Remove contacts',
	removeInstructionalText: "Tem certeza de que deseja remover esses contatos do seu projeto? Se esses contatos pertencerem a várias entidades, eles serão removidos de todas as entidades. Se você precisar remover um contato de uma entidade individual, selecione para editar seu acesso.",
	removeSelectedContacts: "Contatos selecionados",

	domainNotPermitted: "O domínio de um ou mais administradores da entidade não é permitido para esta entidade.",
	listView: "Exibição de lista",
	cardView: "Visualização do cartão",

	recordsNotAvailable: "Registros não disponíveis",

	// Project Layout Update
	welcomeLabel: "Bem-vindo",
	activeProjectsInstructionalText: "Você tem acesso aos projetos do EY Canvas Oversight listados aqui. Selecione um módulo para navegar até ele ou clique em uma contagem para ver os detalhes de cada um de seus projetos.",
	otherProjectsInstructionalText: "Seus projetos com o EY Canvas estão conectados aos projetos EY Canvas Oversight listados aqui. Você não tem acesso a esses projetos. Fale com um dono de projeto ou administrador de entidade para obter acesso.",
	completedProjectsInstructionalText: "Seus projetos concluídos do EY Canvas Oversight estão listados aqui. Selecione a opção <b>Roll Forward</b> para usar seu projeto concluído como modelo ao criar um novo projeto.",
	goToLabel: "Ir para",
	entityAdmins: "Administradores da entidade",
	entityAdmin: "Administração da Entidade",
	keyContacts: "Principais contatos",
	keyContact: "Contato chave",
	contactListLabel: "Lista de contatos",
	draftlabel: "Rascunho",
	projectWizard: "Assistente de projeto",
	noEntityAdminsAdded: "Nenhum administrador de entidade associado",
	addProjectOwner: "Adicionar Proprietário do Projeto",
	addProjectOwnerInstrText: "Pesquise um usuário usando seu nome ou e-mail para adicioná-lo como proprietário do projeto selecionado.",
	projectSummary: "Resumo do Projeto",
	privacyNotice: "Aviso de privacidade",
	groupOversightProject: "Grupo do Projeto Oversight (novo!)",
	groupOversightProjectTooltip: "Em <b>Grupo de projetos Oversight</b>, você pode identificar seus engagements primários e/ou regionais do EY Canvas para os quais está criando um projeto Oversight da EY. Os engagements regionais e/ou componentes do EY Canvas identificados na estrutura do seu Grupo EY Canvas serão <b>automaticamente</b> preenchidos como parte da configuração do projeto Oversight da EY. <br><br> Além disso, esses tipos de projetos terão acesso a um módulo de avaliação de risco do Grupo, onde as atividades de avaliação de risco podem ser visualizadas para o(s) engagements(s) Primário, Regional e/ou Componente.",
	oversightProject: "Projeto Oversight (auditorias estatísticas)",
	oversightProjectTooltip: "Em projetos Oversight (auditorias estatísticas), você pode selecionar manualmente seu(s) cliente(s) e, em seguida, seu(s) engagement(s) associado(s) do EY Canvas, para os quais você está criando um projeto Oversight da EY.",

	// Group Risk Assessment
	noGroupRiskAssessmentForSelection: "Não há nenhuma atividade de avaliação de risco do Grupo para este projeto de EY Oversight.",
	engagementData: "Dados do engagement",
	engagementDetails: "Detalhes do engagement",
	reconciliations: "Reconciliações",
	nextComponent: "Próximo componente",
	prevComponent: "Componente anterior",
	allAccounts: "Todas as contas",
	generateEmail: "Gerar e-mail",
	reconciliationDetailInstructional: "As informações abaixo resumem as contas totais e os riscos relacionados à equipe do componente na estrutura do grupo principal da equipe EY Canvas. Contas e riscos devem ser mapeados para a conta e risco equivalentes no engagement da equipe do componente EY Canvas.",
	primaryTeamAccountName: "'Nome da conta da equipe primária",
	componentTeamAccountName: "Nome da conta da equipe do componente",
	designation: "Designação",
	openAccounts: "Abrir contas",
	componentTeamAccounts: "Contas de equipe componentes",
	mapAccountsMessage: "Cada conta da equipe primária deve ter pelo menos uma conta da equipe componente mapeada. {button} para começar.",
	primaryTeamAccountStatus: "Status da conta da equipe primária",
	totalAccounts: "Total de contas",
	assessedAccounts: "Contas avaliadas",
	primaryTeamRiskStatus: "Status de risco da equipe primária",
	openRisks: "Riscos abertos",
	assessedRisks: "Riscos avaliados",
	totalRisks: "Riscos totais",
	primaryTeamRiskDesignationAndName: "Designação e nome do risco da equipe primária",
	primaryTeamAccountsRelatedToRisk: "Conta(s) da equipe primária relacionada(s) ao risco",
	componentTeamRisksAndRelatedAccounts: "Riscos da equipe do componente e contas relacionadas",
	relateRisks: "Relacionar riscos",
	relateRisksMessage: "Cada conta de equipe primária deve ter pelo menos um risco de equipe de componente mapeado. {button} para começar.",
	pspIndexesHeader: "PSP",
	pspIndexes: "Índice(s) PSP",
	markAssessed: "Marca avaliada",
	markReOpen: "Reabrir",
	riskMarkAssessedMessage: "Revise os riscos da equipe primária e componente relacionados. Assim que houver um mapeamento completo, {button}.",
	riskMarkOpenMessage: "Se alterações precisarem ser feitas em riscos que já foram marcados como avaliados, {button} o risco. Este agrupamento de risco aparecerá na visualização de Riscos Abertos.",
	markAssessedSuccessMessage: "A conta relacionada foi marcada como avaliada com sucesso. Para revisar a conta, vá para a visualização de avaliados.",
	reopenAssessedAccount: "Reabrir",
	reopenAssessedAccountMessage: "Se alterações precisarem ser feitas em contas que já foram marcadas como avaliadas, {button} a conta. Este agrupamento de conta aparecerá no bucket Aberto.",
	reopenSuccessMessage: "A conta relacionada foi reaberta com sucesso. Para revisar a conta, vá para a visualização aberta.",
	teamAccountMappedMessage: "Revise as contas da equipe primária e componente que estão mapeadas. Assim que houver um mapeamento completo, {button}.",
	teamAccountWasPreviousAssessedMessage: 'This primary and component team account grouping was previously marked assessed but there were changes to the account(s). Review primary and component team accounts to ensure the mapping is still correct. Once complete, {button}.',
	createComment: "Criar comentário",
	editComment: "Editar comentário",
	commentTitle: "Comentário",
	createCommentInstructionalText: "Insira os detalhes do comentário para a conta ou risco selecionado e selecione 'Salvar' para finalizar.",
	editCommentInstructionalText: "Editar detalhes do comentário para a conta ou risco selecionado e selecione 'Salvar' para finalizar.",
	lastModified: "Última modificação",
	addComment: "Adicionar comentário",
	accountDescription: "Selecione Contas abertas para visualizar as contas da equipe primária que não foram relacionadas às contas da equipe componente e marcadas como avaliadas. Selecione Contas avaliadas para visualizar as contas da equipe principal que foram avaliadas.",
	riskDescription: "Selecione Riscos Abertos para visualizar riscos da equipe primária que não foram relacionados a riscos da equipe componente e marcados como avaliados. Selecione Riscos Avaliados para visualizar riscos da equipe primária que foram avaliados.",
	successAssessedMessage: "Os riscos relacionados foram marcados como avaliados com sucesso. Para visualizar os riscos, vá para a visualização de avaliados.",
	successReOpenMessage: "Os riscos relacionados foram reabertos com sucesso. Para visualizar os riscos, vá para a visualização aberta.",

	// Relate risks modal
	relateRisksModalTitle: "Relacionar riscos da equipe componente aos riscos da equipe primária",
	relateRisksModalInstructionalText: "Selecione os riscos da equipe componente abaixo para relacionar ao risco da equipe primária selecionada.",
	primaryRegionTeamRisk: "Risco da equipe primária:",
	primaryTeamRiskLabel: "Risco da equipe primária",
	thereIsNoDataToDisplayForThisSelection: "Não há dados para exibir para esta seleção.",
	accountAndAsssociated: "Conta(s) e PSP(s) associados",
	disabledRegionComponentTeamRiskLabel: "Este risco da equipe componente já está mapeado para outro risco da equipe primária. Um risco da equipe componente pode ser mapeado apenas para um risco da equipe primária. Selecione 'Relacionar riscos' para o risco primário relevante para desvincular este risco, conforme aplicável.",
	selectOneOrMore: "Selecione um ou mais",

	relateAccountsModalTitle: "Relacionar contas da equipe componente às contas da equipe primária",
	relateAccountName: "Conta da equipe primária:",
	relateAccountpspIndex: "Índice de PSP da equipe primária:",
	relateAccountpspIndexes: "Índices de PSP da equipe primária:",
	relateAccountInstructionalText: "Selecione as contas da equipe componente abaixo para relacionar à conta da equipe primária selecionada.",
	pspIndexcountLabel: "Índices de PSP relacionados à conta da equipe primária/regional",
	relateAccounts: "Relacionar contas",

	viewComponentTeamAccountsText: "Ver contas da equipe componente",
	componentTeamAccountsModalTitle: "Contas da equipe componente não relacionadas e/ou não aplicáveis",
	componentTeamAccountsModalInstructionalText: "As contas da equipe componente devem ser relacionadas a uma conta da equipe primária. Retorne à página subjacente para relacionar contas. Se a conta da equipe componente não for aplicável à auditoria do grupo, marque a conta como \'Não aplicável\'.",
	componentTeamAccountsModalNotApplicableInstructionalText: "As contas da equipe componente não aplicáveis são marcadas dessa forma porque não são aplicáveis à auditoria do grupo. Se uma conta estiver listada abaixo por engano, mova a conta de volta para \'Não relacionada\' para relacionar esta conta a uma conta da equipe primária.",
	notRelatedTab: "Não relacionada",
	notApplicableTab: "Não aplicável",
	unmapped: "Não mapeada",
	unrelate: "Desvincular",
	action: "Ação",
	notApplicableActionTitletip: "Selecionar 'Desvincular' moverá o risco para a aba 'Não relacionada'. Riscos que estão 'Não relacionados' devem ser relacionados a um risco da equipe primária ou marcados como 'Não aplicáveis' se não forem aplicáveis à auditoria do grupo.",
	notRelatedActionTitletip: "Selecionar 'Não aplicável' moverá o risco para a aba 'Não aplicável'. Riscos da equipe componente que são 'Não aplicáveis' não são aplicáveis à auditoria do grupo.",

	higherInheritRisk: "Risco inerente mais alto",
	lowerInheritRisk: "Risco inerente mais baixo",
	riskAssociated: "Risco associado",
	riskAssociatedHigher: "Risco associado e contribui para o risco inerente mais alto",

	viewComponentTeamRisks: "Ver riscos da equipe componente",
	unmappedRisksModalTitle: "Riscos da equipe componente não relacionados e/ou não aplicáveis",
	unmappedRisksModalInstructional: "Os riscos da equipe componente devem ser relacionados a um risco da equipe primária. Retorne à página subjacente para relacionar riscos. Se o risco da equipe componente não for aplicável à auditoria do grupo, marque o risco como 'Não aplicável'.",
	notApplicableRisksModalInstructional: "Os riscos da equipe componente não aplicáveis são marcados dessa forma porque não são aplicáveis à auditoria do grupo. Se um risco estiver listado abaixo por engano, mova o risco de volta para 'Não relacionado' para relacionar este risco a um risco da equipe primária.",
	added: "Adicionado",
};

export const temporaryLabels = {
	dryDock: "Drydock",
	darkMode: "Modo escuro",
	dashboard: "Dashboard",
	projects: "Projetos",
	scopeStrategy: "Escopo e Estratégia",
	accountSummary: "Resumo da conta",
	scotSummary: "Resumo da SCOT",
	craSummary: "Resumo do CRA",
	itSummary: "Resumo de TI",
	SPSummary: "Resumo da Avaliação Substantiva",
	auditPlan: "Plano de auditoria",
	conclusion: "Conclusão",
	findings: "Descobertas",
	changesReport: "Alterações após a data do relatório",
	teamMember: "Independência do membro da equipe",
	archiveChecklist: "Lista de verificação do arquivo",
	enagagementmanagement: "Gerenciamento do engagement",
	integration: "Integração",
	guidedWorkflow: "Guia do Fluxo de trabalho",
	copyrightMessage: "Copyright © <ano>. Todos os direitos reservados"
};

export const createGRAProjectLabels = {
	creationInstructional: "Insira um nome de projeto e selecione um engagement primário ou regional do EY Canvas na lista abaixo para criar um projeto do EY Oversight. <br> Com base no engagement selecionado, o(s) engagement(s) do EY Canvas identificados na estrutura do Grupo do EY Canvas serão preenchidos automaticamente como parte da configuração deste projeto. Clique no {link} para obter mais informações sobre o EY Canvas Oversight.",
	projectName: labels.projectName,
	engagements: labels.engagementsLabel,
	searchPlaceholder: "Pesquise o nome, ID ou nome do cliente do engagement do EY Canvas",
	noAccessToEng: "Você não tem acesso a nenhum engagement do EY Canvas.",
	noDataToDisplay: labels.noDataFound,
	save: labels.save,
	cancel: labels.cancelLabel,
	engagementsRequiredMessage: "Selecione pelo menos um engagement para salvar.",
	userGuideLinkText: "Guia do usuário"
};

export const deleteCommentModalLabels = {
	titleText: "Excluir comentário",
	instructionalText: "Você tem certeza de que deseja excluir o comentário?",
	triggerText: "Excluir",
	confirmLabel: "Confirmar",
	cancelLabel: "Cancelar",
	closeLabel: "Fechar"
}

export const gaRoleType = [{
	id: GARoleTypeId.Primary,
	label: "Primário"
},
{
	id: GARoleTypeId.Region,
	label: "Região"
},
{
	id: GARoleTypeId.Component,
	label: "Componente"
}
];

export const engagementTableLabels = {
	engagementName: "Nome do engagement",
	clientName: labels.clientName,
	type: labels.typeLabel,
	gaRoleType
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.formLengthMessage
};

export const activityLogTypes = {
	ProjectCreated: "Data de criação do projeto",
	GAComponentCreated: "Componente adicionado",
	GAComponentRemoved: "Componente removido",
	GAComponentUnlinked: "Componente desvinculado",
	AccountAdded: "Conta adicionada",
	AccountRemoved: "Conta removida",
	AccountDesignationChanged: "Designação da conta alterada",
	AccountEstimateChanged: "Conta de estimativa alterada",
	AccountExecutionTypeChanged: "Tipo de execução de conta alterado",
	AssertionAssociated: "Assertiva associada",
	AssertionUnassociated: "Assertiva não associada",
	AssertionInherentRiskChanged: "Mudança no risco inerente",
	AssertionControlRiskDesignationChanged: "Mudança na designação de risco de controle",
	RiskCreated: "Risco criado",
	RiskRemoved: "Risco removido",
	RiskAssociated: "Risco associado",
	RiskUnassociated: "Risco não associado"
};

export const activityTableLabels = {
	sourceEngagement: "Fonte do engagement",
	activityType: "Tipo de atividade",
	objectImpacted: "Objeto impactado",
	relatedObjectImpacted: "Objeto impactado relacionado",
	relatedSecondaryObjectImpacted: "Objeto secundário relacionado impactado",
	activityDate: "Data da atividade"
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: "Nome do risco da equipe componente",
	details: "Detalhes"
};

export const riskTypes = [{
	id: '1',
	label: "Risco significativo",
},
{
	id: '2',
	label: "Risco de fraude",
},
{
	id: '3',
	label: "Risco inerente"
}
];

export const engagementLabels = {
	accountName: "Nome da conta / divulgação",
	accountTypeName: "Designação",
	canvasEngagementId: "ID do engagement",
	controlRiskTypeName: "Risco de Controle",
	engagementDescription: "Nome do engagement",
	inherentRiskTypeName: "Risco inerente",
	assertionName: "Assertiva",
	pspIndexTitle: "Índice PSP",
	riskName: "Nome do risco",
	riskTypeName: "Tipo de risco",
	relatedTasks: "Tarefas relacionadas",
	taskStatus: "Status da tarefa",
	controlRiskAssessment: "Avaliação de risco de controle"
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
	lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
	lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed,
};

export const reconciliationsTableLabels = {
	show: labels.show,
	noDataToDisplay: "Não há dados para exibir para esta tabela.",
	unselectedEntities: "Não há dados de reconciliação para este projeto do EY Oversight. Relacione componentes a contas no fluxo de instruções do Grupo em seu engagement no EY Canvas da equipe primária para que os dados de reconciliação sejam exibidos aqui.",
	columns: {
		components: "Componentes",
		open: "Aberto",
		assessed: "Avaliado",
		total: "Total"
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const relateAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: "Conta da equipe componente",
		pspIndexes: "Índices de PSP",
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent,
	relateAccountTableDisabledRowToolTip: "Esta conta da equipe componente já está mapeada para outra conta da equipe primária. Uma conta da equipe componente pode ser mapeada apenas para uma conta da equipe primária. Selecione 'Relacionar contas' para a conta primária relevante para desvincular esta conta, conforme aplicável.",
};

export const notRelatedAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: relateAccountsTableLabels.columns.accountName,
		pspIndexes: "Índice(s) de PSP",
		notRelated: {
			actionColumnName: labels.action,
			titleTip: "Marcar uma conta como \'Não aplicável\' moverá a conta para a aba \'Não aplicável\'. As contas devem ser marcadas como \'Não aplicáveis\' se não forem aplicáveis à auditoria do grupo.",
			actionLabel: labels.notApplicableTab
		},
		notApplicable: {
			actionColumnName: labels.action,
			titleTip: "Selecionar \'Desvincular\' moverá a conta para a aba \'Não relacionada\'. As contas que estão \'Não relacionadas\' devem ser relacionadas a uma conta da equipe primária ou marcadas como \'Não aplicáveis\' se não forem aplicáveis à auditoria do grupo.",
			actionLabel: labels.unrelate
		}
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const unmappedRisksTableColumnLabels = {
	riskName: "Risco da equipe componente",
	actions: "Ação",
};

export const AdminUserErrors = {
	userError: "Usuário não encontrado."
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "Você não tem as permissões necessárias para executar esta ação."
};

export const Errors = {
	106: "Você não tem as permissões necessárias para executar esta ação.",
	107: "Você não tem as permissões necessárias para realizar esta ação.",
	111: "Você não pode delegar acesso a si mesmo.",
	112: "Usuário não encontrado.",
	310: "Projeto não encontrado.",
	314: "O domínio para um ou mais administradores de grupo não é permitido para este grupo.",
	316: "Você deve ser um proprietário de projeto ou administrador de grupo para adicionar membros da equipe. Fale com o dono do projeto para ter acesso.",
	317: "Somente membros internos podem ser adicionados como proprietários do projeto. Seguem usuários externos: {0}. Atualize a página e tente novamente. Entre em contato com a Central de Ajuda se o erro persistir.",
	318: "O domínio para {0} não é permitido para o seguinte grupo: {1}",
	319: "Este projeto foi concluído por outro proprietário do projeto. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
	321: "Você deve ser um proprietário do projeto para completar esta ação. Fale com o dono do projeto para ter acesso.",
	323: "Este grupo foi excluído por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
	324: "Você deve ser um proprietário de projeto para este projeto para completá-lo. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
	325: "Você deve ser um proprietário de projeto ou administrador de grupo para fazer essas alterações. Fale com o dono do projeto para ter acesso.",
	326: "Complete todos os campos necessários para salvar este projeto. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
	327: "Projeto já salvo.",
	328: "O membro da equipe que você está tentando adicionar já é um membro deste grupo. Atualize a página e tente novamente. ",
	330: "O último proprietário do projeto não pode ser excluído",
	331: "Um ou mais grupos foram excluídos por outro membro da equipe. Atualize a página e tente novamente. Contate o Help Desk se o erro persistir. ",
	332: "Pelo menos um dono de projeto é necessário. Você não pode se retirar deste projeto.",
	341: "Você não tem acesso aos clientes ou engagements selecionados.",
	343: "Você só pode excluir projetos ativos e rascunhos. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir. ",
	344: "Você deve ser um proprietário do projeto para excluir este projeto. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir. ",
	345: "Este projeto foi excluído por outro membro da equipe. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir.",
	346: "Outro proprietário de projeto ou administrador de entidade já revisou o acesso para {0}. Atualize o log de acesso e tente novamente.",
	347: "Você deve ser proprietário de um projeto ou administrador de entidade para adicionar ou remover contatos deste projeto. Fale com o proprietário do projeto para solicitar acesso.",
	348: "Você só pode remover contatos de entidades que você administra. Os seguintes contatos pertencem a entidades das quais você não é administrador e não podem ser removidos: {0}.",
	360: "Você deve ser o dono do projeto para concluir esta ação.",
	361: "Você deve ser um dono de projeto ou administrador de entidade para executar esta ação. Fale com o dono do projeto para solicitar acesso.",
	362: "Você só pode gerenciar o acesso dos contactos pertencentes às entidades que administra. Os seguintes contatos pertencem a entidades das quais você não é administrador e seus acessos não podem ser editados: {0}.",
	364: "Você está tentando editar o acesso de um ou mais contatos que foram removidos deste projeto. Atualize a página e tente novamente.",
	365: "Você está tentando editar os atributos de um ou mais contatos que foram removidos deste projeto: {0} Atualize a página e tente novamente.",
	366: "Você só pode editar atributos para contatos que pertencem às entidades que você administra. Os seguintes contatos pertencem a entidades das quais você não é administrador: {0}",
	367: "A coluna personalizada que você está editando foi excluída por outro membro da equipe. Atualize a página e tente novamente.",
	368: "A opção de coluna personalizada que você está editando foi excluída por outro membro da equipe. Atualize a página e tente novamente.",
	369: "Você deve ser um dono do projeto para realizar esta ação.",
	370: "Você só pode editar atributos para contatos que pertencem às entidades que você administra. Os seguintes contatos pertencem a entidades das quais você não é administrador: {0}",
	372: "Você deve ser o dono do projeto para realizar esta ação.",
	373: "Não é possível excluir um dono de projeto da página da lista de contatos. Vá para o assistente do projeto para executar a ação solicitada.",
	374: "Você não pode remover a si mesmo como Proprietário do Projeto deste projeto.",
	375: "Não é possível remover o último Proprietário do Projeto de um projeto. Pelo menos 1 Proprietário do Projeto deve permanecer.",
	376: "Você deve ser Proprietário do projeto para adicionar/remover um Proprietário do projeto ou um administrador de Entidade de um projeto. Os seguintes contatos não podem ser removidos: {0}",
	378: "O domínio não pode ser removido porque está em uso por um contato na página da lista de contatos deste Projeto Oversight. Vá para a página da lista de contatos e remova os contatos deste domínio e retorne aqui para remover o domínio.",
	502: "Falha ao obter chamada de engagements. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir. ",
	503: "Você não tem acesso para os Clientes selecionados. ",
	601: "Falha ao obter chamada de clientes. Atualize a página e tente novamente. Entre em contato com o Help Desk se o erro persistir. ",
	1605: "O usuário selecionado já existe",

	1803: "Operação de marcação executada com dados de projeto inválidos. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk para obter mais assistência.",
	1804: "Você deve ser o dono deste projeto para executar esta operação de marcação.",
	1901: "Falha na chamada da API de envio de mensagem.",
	1902: "A mensagem não pode estar vazia.",
	1903: "O tamanho permitido da mensagem é de 200 caracteres.",
	1904: "O tamanho permitido do texto de retorno de chamada é de 50 caracteres.",
	1905: "O tamanho permitido do uri de retorno de chamada é de 50 caracteres.",
	1906: "Você deve selecionar pelo menos um filtro para continuar.",
	1907: "Os destinatários não podem ser repetidos.",
	1908: "O engagement não pode ficar vazio.",
	1909: "O tipo de mensagem não é um valor válido.",
	1910: "O destinatário não pode ser um valor vazio.",
	1911: "A mensagem de brinde não pode estar vazia.",
	1912: "O tipo de destinatário não é um valor válido.",
	1913: "Você não tem o acesso apropriado para enviar uma notificação. Fale com um proprietário de projeto ou administrador de entidade para solicitar acesso.",
	1914: "As notificações só podem ser enviadas para contatos internos. Revise os destinatários da mensagem e remova os contatos externos para continuar.",
	2101: "O EY Policy Authoring, Approvals and Notification Service​ não está disponível no momento. Não podemos confirmar se todas as políticas relevantes foram concluídas. Se você não revisou as políticas relevantes, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

	// Reconciliation
	2701: "Falha na chamada de obter todas as reconciliações.",
	2702: "Solicitação inválida.",
	2703: "Falha na chamada de obter reconciliações por ID.",
	2704: "Falha na chamada de obter riscos por ID.",
	2705: "Projeto não encontrado no banco de dados.",
	2706: "Conta não encontrada no banco de dados.",
	2707: "Engagement não encontrado no banco de dados.",
	2708: "Falha na chamada de criar comentário.",
	2709: "O comentário já foi criado. Atualize a página e tente novamente.",
	2710: "Falha na chamada de patch da conta do componente do grupo.",
	2711: "Conta do componente do grupo não encontrada no banco de dados.",
	2712: "O comentário de justificativa não pode estar vazio.",
	2713: "O comentário de justificativa não pode ter mais de 4000 caracteres.",
	2714: "O risco do componente do grupo não foi encontrado.",
	2715: "O componente do grupo não foi encontrado.",
	2718: "Falha na chamada de atualização de reconciliação.",
	2720: "Este item foi editado ou excluído por outro usuário. Por favor, atualize e tente novamente.",
	2721: "O comentário já foi criado. Atualize a página e tente novamente.",
};

export const clientValidationErrors = {
	ErrorAtleastOneEngagementAssociationRequired: "Relacione pelo menos um engagement ao gráfico organizacional para continuar.",
	ErrorAtleastOneGroupAssociationRequired: "Relacione pelo menos um engagement ao gráfico organizacional para continuar.",
	ErrorStep2DataNotComplete: "Insira um nome para cada entidade no gráfico organizacional para continuar."
};

export const engagementsViewBy = [{
	id: 0,
	label: "Todos",
	value: "Todos"
},
{
	id: 1,
	label: "Por país",
	value: "País",
	groupAttributeName: 'countryName'
},
{
	id: 2,
	label: "Por escritório primário",
	value: "Por região",
	groupAttributeName: 'regionName'
},
{
	id: 3,
	label: "Por tipo de engagement",
	value: "Tipo",
	groupAttributeName: 'profileNature'
}
];

export const milestones = [{
	id: 1,
	label: "Escopo",
	auditPhaseId: 1,
	value: 1
},
{
	id: 2,
	label: "Estratégia",
	auditPhaseId: 1,
	value: 2
},
{
	id: 3,
	label: "Walkthroughs",
	auditPhaseId: 2,
	value: 3
},
{
	id: 4,
	label: "Teste de Controle de Interim",
	auditPhaseId: 2,
	value: 4
},
{
	id: 5,
	label: "Teste Substantivo de Interim",
	auditPhaseId: 2,
	value: 5
},
{
	id: 6,
	label: "Walkthroughs (processos de fim de ano)",
	auditPhaseId: 2,
	value: 6
},
{
	id: 7,
	label: "Teste de controle de fim de ano ",
	auditPhaseId: 2,
	value: 7
},
{
	id: 8,
	label: "Teste Substantivo de fim de ano ",
	auditPhaseId: 2,
	value: 8
},
{
	id: 9,
	label: "Conclusão",
	auditPhaseId: 3,
	value: 9
},
{
	id: 10,
	label: "N/A",
	auditPhaseId: 2,
	value: 10
},
{
	id: 11,
	label: "Execução",
	auditPhaseId: 2,
	value: 11
},
{
	id: 12,
	label: "Atividades de qualidade de escopo e estratégia",
	auditPhaseId: 1,
	value: 12
},
{
	id: 13,
	label: "Outro escopo e estratégia ",
	auditPhaseId: 1,
	value: 13
},
{
	id: 14,
	label: "CRA",
	auditPhaseId: 1,
	value: 14
},
{
	id: 15,
	label: "Avaliação de Riscos e Materialidade",
	auditPhaseId: 1,
	value: 15
},
{
	id: 16,
	label: "Finalizar escopo e estratégia ",
	auditPhaseId: 1,
	value: 16
},
{
	id: 17,
	label: "Gerenciamento de projeto post-interim",
	auditPhaseId: 2,
	value: 17
}
];

export const daysOptions = [{
	id: daySelection.tomorrow,
	value: daySelection.tomorrow,
	label: "amanhã"
},
{
	id: daySelection.next3days,
	value: daySelection.next3days,
	label: "Próximos 3 dias"
},
{
	id: daySelection.next5days,
	value: daySelection.next5days,
	label: "Próximos 5 dias"
},
{
	id: daySelection.next10days,
	value: daySelection.next10days,
	label: "Próximos 10 dias"
},
{
	id: daySelection.next30days,
	value: daySelection.next30days,
	label: "Nos próximos 30 dias"
}
];

export const auditPhases = [{
	id: 1,
	label: "Scope & strategy"
},
{
	id: 2,
	label: "Execução"
},
{
	id: 3,
	label: "Conclusão"
}
];

export const findings = [{
	id: 1,
	label: "Distorções",
	subTitle: "Distorções por tipo "
},
{
	id: 2,
	label: "Deficiências",
	subTitle: "Deficiências por severidade"
}
];
export const risks = [{
	id: 1,
	label: '',
	subTitle: "Por tipo"
}];

export const auditStrategies = [{
	id: 1,
	label: "Substantivo",
	subTitle: "Procedimentos substantivos por tipo"
},
{
	id: 2,
	label: "Controles",
	subTitle: "Controles por estratégia de teste"
},
{
	id: 3,
	label: "IT",
	subTitle: "Procedimentos de TI por estratégia de teste "
}
];

export const auditInsights = [{
	id: 1,
	label: "Por função de grupo "
},
{
	id: 2,
	label: "Todos"
}
];

export const projectStatus = {
	Active: "ativo",
	Draft: "rascunho",
	Cancel: "Cancelar",
	Complete: "concluído",
	Delete: "excluir"
};

export const ProjectStatusLabels = [{
	label: "Inicial",
	id: 1,
	value: 'Initial'
},
{
	label: "Rascunho",
	id: 2,
	value: 'Draft'
},
{
	label: "Ativo",
	id: 3,
	value: 'Active'
},
{
	label: "Cancelado",
	id: 4,
	value: 'Cancelled'
},
{
	label: "Concluído",
	id: 5,
	value: 'Completed'
},
{
	label: "Excluído",
	id: 6,
	value: 'Delete'
}
];

export const projectTeamEngagementTableGroup = [{
	id: 1,
	label: "Atribuições de preparador"
},
{
	id: 2,
	label: "Atribuições de revisores"
}
];

export const archiveReportQualifiedType = [{
	id: archiveReportQualifiedTypeId.notSelected,
	label: "Não selecionado"
},
{
	id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
	label: "Não qualificado - Com ênfase de assunto"
},
{
	id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
	label: "Não qualificado - Sem ênfase de assunto"
},
{
	id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
	label: "Qualificado - Com ênfase de assunto"
},
{
	id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
	label: "Qualificado - Sem ênfase de assunto"
},
{
	id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
	label: "Opinião adversa - Com ênfase de assunto"
},
{
	id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
	label: "Opinião adversa - Sem ênfase de assunto"
},
{
	id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
	label: "Abstenção de opinião - Com ênfase"
},
{
	id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
	label: "Abstenção de opinião - Sem ênfase"
}
];

export const strategyTableGroup = [{
	id: 1,
	label: ''
}];

export const roleForMember = [{
	id: roles.partnerInCharge,
	label: "Sócio responsável",
	roleAbbreviation: "PTR EM CHG"
},
{
	id: roles.engagementPartner,
	label: "Sócio do Engagement",
	roleAbbreviation: "EP"
},
{
	id: roles.executiveDirector,
	label: "Diretor Executivo",
	roleAbbreviation: "EXEC DIR"
},
{
	id: roles.principal,
	label: "principal",
	roleAbbreviation: "PRINCIPAL"
},
{
	id: roles.seniorManager,
	label: "Gerente Sênior",
	roleAbbreviation: "GERENTE S."
},
{
	id: roles.manager,
	label: "gerente",
	roleAbbreviation: "GERENTE"
},
{
	id: roles.senior,
	label: "sênior",
	roleAbbreviation: "SÊNIOR"
},
{
	id: roles.staff,
	label: "Staff",
	roleAbbreviation: "STAFF"
},
{
	id: roles.intern,
	label: "Intern",
	roleAbbreviation: "Intrn"
},
{
	id: roles.engagementQualityReviewer,
	label: "Revisor de qualidade de engajamento",
	roleAbbreviation: "EQR"
},
{
	id: roles.otherPartner,
	label: "Outro Sócio",
	roleAbbreviation: "OUTROS PTR"
},
{
	id: roles.gdsStaff,
	label: "GDS - Staff",
	roleAbbreviation: "GDS-STAFF"
},
{
	id: roles.advisory,
	label: "Advisory (ITRATASHuman Capital ou Outros)",
	roleAbbreviation: "Adv"
},
{
	id: roles.tax,
	label: "Tax",
	roleAbbreviation: "Tax"
},
{
	id: roles.executiveSupportServices,
	label: "Serviços de Suporte Executivo",
	roleAbbreviation: "ESS"
},
{
	id: roles.generalCounsel,
	label: "Conselheiro Geral",
	roleAbbreviation: "GCO"
},
{
	id: roles.auditQualityReviewer,
	label: "Revisor de qualidade de auditoria",
	roleAbbreviation: "AQR"
},
{
	id: roles.mlComponentTeam,
	label: "Equipe de componentes ML",
	roleAbbreviation: "MCT"
},
{
	id: roles.clientSupervisor,
	label: "Supervisor de Clientes",
	roleAbbreviation: "Clnts"
},
{
	id: roles.clientStaff,
	label: "Funcionários do Cliente",
	roleAbbreviation: "ClntSt"
},
{
	id: roles.internalAuditSupervisor,
	label: "Supervisor de Auditoria Interna",
	roleAbbreviation: "IASup"
},
{
	id: roles.internalAuditStaff,
	label: "Equipe de Auditoria Interna",
	roleAbbreviation: "IAST"
},
{
	id: roles.regulator,
	label: "regulador",
	roleAbbreviation: "Reglr"
},
{
	id: roles.other,
	label: "Outros (por exemplo, revisão de due diligence)",
	roleAbbreviation: "outro"
},
{
	id: roles.office,
	label: "escritório",
	roleAbbreviation: "Off"
},
{
	id: roles.area,
	label: "área",
	roleAbbreviation: "área"
},
{
	id: roles.industry,
	label: "indústria",
	roleAbbreviation: "IND"
},
{
	id: roles.national,
	label: "nacional",
	roleAbbreviation: "Nat"
},
{
	id: roles.global,
	label: "global",
	roleAbbreviation: "GBL"
},
{
	id: roles.gsdSenior,
	label: "GDS - Sênior",
	roleAbbreviation: "GDS-SENIOR"
},
{
	id: roles.gsdManager,
	label: "GDS - Gerente",
	roleAbbreviation: "GDS-Gerente"
}
];

export const toggleCCPEntityOptions = [{
	id: toggleCCPEntityDetail.comingDue,
	label: labels.comingDue
},
{
	id: toggleCCPEntityDetail.overdue,
	label: labels.taskStatusOverdue
},
{
	id: toggleCCPEntityDetail.returned,
	label: labels.returned
}
];


export const reportReadinessSeries = [{
	id: readinessReportCategories.comingDueOver2Weeks,
	label: `> 2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.comingDue12Weeks,
	label: `1-2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.comingDueUnder1Week,
	label: `< 1{break}${labels.week}`
},
{
	id: readinessReportCategories.overDueUnder1Week,
	label: `< 1{break}${labels.week}`
},
{
	id: readinessReportCategories.overDue12Weeks,
	label: `1-2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.overDueOver2Weeks,
	label: `> 2{break}${labels.weeks}`
}
];

export const natureOfEngagementsLabels = {
	[natureOfEngagements.auditStatements.id]: "Auditoria das demonstrações financeiras",
	[natureOfEngagements.integratedStatements.id]: "Auditoria integrada das demonstrações financeiras e controle interno sobre relatórios financeiros",
	[natureOfEngagements.reviewStatements.id]: "Revisão das demonstrações financeiras provisórias",
	[natureOfEngagements.nonAuditAccount.id]: "Engagement de não auditoria com funcionalidade de conta/asserção/SCOT",
	[natureOfEngagements.nonAuditWorkPlan.id]: "Engagement sem auditoria apenas com a funcionalidade do plano de trabalho"
};

export const AdminRoles = [{
	label: "Leitor de administração de aplicativos",
	id: 1
},
{
	label: "Escritor de administrador de aplicativos",
	id: 2
},
{
	label: "Super administrador de aplicativos",
	id: 3
}
];

export const userType = [{
	value: 1,
	label: "Interno"
},
{
	value: 2,
	label: "Externo"
}
];

export const MessageType = [{
	value: 1,
	label: "E-mail"
},
{
	value: 2,
	label: "Notificação"
}
];

export const groupRole = [{
	value: 1,
	label: "Time primário",
	id: 1,
	selected: false,
	disabled: false
},
{
	value: 2,
	label: "Time regional",
	id: 2,
	selected: false,
	disabled: false
}, {
	value: 3,
	label: "Time component",
	id: 3,
	selected: false,
	disabled: false
},
{
	value: 4,
	label: "Reporte da equipe de componentes para auditores não EY",
	id: 4,
	selected: false,
	disabled: false
},
{
	value: 5,
	label: "Não aplicável",
	id: 5,
	selected: false,
	disabled: false
}
];

export const accessLogResource = [{
	id: 1,
	label: "Contatos para adicionar"
},
{
	id: 2,
	label: "Contatos para remover"
}
]

export const addContactsTabsResource = [{
	id: 1,
	label: "Accesso"
},
{
	id: 2,
	label: "Atributos"
},
{
	id: 3,
	label: "Marcações"
}
]

export const tags = [{
	name: "Sócio de auditoria",
	id: 'auditPartner'
},
{
	name: "Gerente do projeto de auditoria",
	id: 'auditEngagementManager'
}, {
	name: "Gerente do projeto GDS",
	id: 'gdsEngagementManager'
}, {
	name: "Sócio de TAX",
	id: 'taxPartner'
}, {
	name: "Gerente do projeto de TAX",
	id: 'taxEngagementManager'
}, {
	name: "Sócio de FAIT",
	id: 'faitPartner'
}, {
	name: "Gerente do projeto de FAIT",
	id: 'faitEngagementManager'
}, {
	name: "Sócio de Advisory",
	id: 'advisoryPartner'
}, {
	name: "Gerente do projeto de Advisory",
	id: 'advisoryEngagementManager'
}, {
	name: "Especialista",
	id: 'specialist'
}, {
	name: "Administrador do cliente",
	id: 'clientadministrator'
}
];

export const dashboardContactViews = [{
	id: dashboardTabId.milestones,
	value: dashboardViewsConstants.milestones,
	tooltipText: "Progresso da auditoria por marco",
	key: "Marcos",
	checked: false
},
{
	id: dashboardTabId.projectManagement,
	value: dashboardViewsConstants.projectManagement,
	tooltipText: "Status das notas de revisão e atribuições, incluindo itens em atraso. Os usuários externos não podem ter acesso ao Painel de Gerenciamento de projetos.",
	key: "Gerenciamento de Projetos",
	checked: false
},
{
	id: dashboardTabId.groupAudit,
	value: dashboardViewsConstants.groupAudit,
	tooltipText: "Status da equipe primário e do componente, incluindo itens devolvidos e vencidos.",
	key: "Auditoria de grupo",
	checked: false
},
{
	id: dashboardTabId.groupRiskAssessment,
	value: dashboardViewsConstants.groupRiskAssessment,
	tooltipText: "Visão da avaliação de risco do grupo nas equipes primárias e de componentes. Esta visualização não estará visível para os clientes.",
	key: "Avaliação de risco de grupo",
	checked: false
},
{
	id: dashboardTabId.canvasClientPortal,
	value: dashboardViewsConstants.ccp,
	tooltipText: "Status da solicitação, incluindo itens a vencer, vencidos e devolvidos.",
	key: "EY Canvas Client Portal",
	checked: false
},
{
	id: dashboardTabId.insights,
	value: dashboardViewsConstants.insights,
	tooltipText: "Comparação de riscos, procedimentos substantivos, estratégia de controle e conclusões entre equipes primárias e componentes. Os usuários externos não podem ter acesso ao Painel do Insights.",
	key: "Insights",
	checked: false
},
{
	id: dashboardTabId.reporting,
	value: dashboardViewsConstants.reporting,
	tooltipText: "Relatar prontidão, modificações e status de conclusão de tarefas por país.",
	key: "Reportando",
	checked: false
}
];

export const colorOptionsLabels = {
	red: "Vermelho",
	orange: "Laranja",
	teal: "Verde azulado",
	blue: "Azul",
	purple: "Roxo",
	green: "Verde ",
	yellow: "Amarelo",
	gray: "Cinza"
};

export const exportToExcelLabels = {
	yes: "Sim",
	no: "Não",
	exportData: labels.exportData,
	exportButtonTitle: "Clique aqui para baixar informações detalhadas sobre solicitações de clientes para as entidades selecionadas no organograma no lado esquerdo deste projeto do EY Oversight.",
	projectInfo: "Informações do projeto",
	exportDate: "Data de exportação",
	engagementName: labels.engagementNameLabel,
	engagementId: labels.engagementId,
	requestItemNumber: "Solicitar número do item",
	requestTitle: "Solicitar título",
	priority: "Prioridade",
	status: labels.status,
	receivedDate: "Data de recebimento",
	dueDate: "Data de vencimento",
	overdue: labels.overdueLabel,
	eyContact: "Contato EY",
	assignedTo: "Atribuído a",
	statusLabels: [{
		id: 1,
		label: "Rascunho"
	},
	{
		id: 2,
		label: "Sem contato com o cliente"
	},
	{
		id: 3,
		label: "Enviado"
	},
	{
		id: 4,
		label: "Erro no sistema"
	},
	{
		id: 5,
		label: "Contato de cliente inválido"
	},
	{
		id: 6,
		label: "Resposta pendente"
	},
	{
		id: 7,
		label: "Recebido"
	},
	{
		id: 8,
		label: "Aceito"
	},
	{
		id: 9,
		label: "Devolvida"
	},
	{
		id: 10,
		label: "Retirado"
	},
	{
		id: 11,
		label: "Envio em andamento"
	},
	{
		id: 12,
		label: "Aceito em andamento"
	},
	{
		id: 13,
		label: "Retirado em andamento"
	},
	{
		id: 14,
		label: "Exclusão em andamento"
	},
	{
		id: 15,
		label: "‘Retorno em andamento’"
	},
	{
		id: 16,
		label: "Resposta em andamento"
	},
	{
		id: 17,
		label: "Excluído"
	},
	{
		id: 18,
		label: "Contato de cliente inválido retornado"
	},
	{
		id: 19,
		label: "Recuperação em andamento"
	},
	{
		id: 20,
		label: "Recuperado"
	},
	{
		id: 21,
		label: "Conclusão em andamento"
	},
	{
		id: 22,
		label: "Recuperação em andamento"
	}
	],
	priorityTypeLabels: [{
		id: 1,
		label: "Baixo"
	}, {
		id: 2,
		label: "Médio"
	}, {
		id: 3,
		label: "Alto"
	}, {
		id: 4,
		label: "Crítico"
	}],

	risks: {
		exportButtonTitle: "Clique aqui para baixar dados detalhados de avaliação de risco para as entidades selecionadas no organograma no painel esquerdo deste projeto do EY Oversight.",
		tabTitle: "Detalhes da avaliação de risco",
		columns: {
			engagementName: labels.engagementNameLabel,
			engagementId: labels.engagementId,
			accountName: "Nome da conta / divulgação",
			pspIndex: "Índice PSP",
			accountType: "Designação",
			assertion: "Assertiva",
			inherentRisk: "Risco inerente",
			controlRisk: "Risco de Controle",
			craValue: "Avaliação de risco de controle",
			riskType: "Tipo de risco",
			riskName: "Nome do risco",
			relatedTasks: "Tarefas relacionadas",
			taskStatus: "Status da tarefa"
		}
	},
	exportButtonTooltip: "Clique aqui para baixar dados de reconciliação detalhados para a equipe primária e a equipe componente relacionada.",
	primaryTeamEngagementName: "Nome do engagement da equipe primária",
	componentTeamEngagementName: "Nome do engagement da equipe componente",
	howToUseThisExport: "Como usar esta exportação:",
	howToUseThisExportText: "TBD - Como usar este texto de exportação",
	reconciliationComponentExportTabTitle: "Contas",
	reconciliationComponentExport: {
		status: "Status",
		primaryTeamAccountName: "Nome da conta da equipe primária",
		componentTeamAccountNames: "Nome(s) da conta da equipe componente",
		pspIndexes: "Índice(s) de PSP",
		designation: "Designação",
		c: "C",
		eo: "E/O",
		mv: "M/V",
		ro: "D&O",
		pd: "A&D",
		comment: "Comentário"
	},
	groupRiskStatusLabels: {
		[groupRiskStatus.open]: "Aberto",
		[groupRiskStatus.assessed]: "Avaliado",
		[groupRiskStatus.mapped]: "Mapeado",
		[groupRiskStatus.unmapped]: "Não mapeada",
		[groupRiskStatus.notApplicable]: "Não aplicável"
	},
	reconciliationExportTabRisks: 'Risks',
	reconciliationExport: {
		status: "Status",
		primaryTeamRiskName: 'Primary team risk name',
		componentTeamRiskName: 'Component team risk name(s)',
		riskDesignation: 'Risk designation',
		accountsRelatedToRisk: 'Account(s) related to risk',
		c: "C",
		eo: "E/O",
		mv: "M/V",
		ro: "D&O",
		pd: "A&D",
		comment: "Comentário"
	}
};

export const accountDesignationsLabels = {
	[accountDesignations.significantAccount]: "Significante",
	[accountDesignations.limitedRiskAccount]: "Risco limitado",
	[accountDesignations.insignificantAccount]: "Insignificante",
	[accountDesignations.otherAccount]: "Outro",
	[accountDesignations.significantDisclosure]: "Divulgação significante"
}

export const riskDesignationsLabels = {
	[riskTypeIds.significant]: 'Significant Risk',
	[riskTypeIds.fraud]: 'Fraud Risk',
	[riskTypeIds.insignificant]: 'Insignificant Risk'
}
